export const internsgipOpportunities = [
  {
    Timestamp: "03/31/2020 07:40:47",
    "Company Name": "Edgy Scribblers",
    "Internship Domain": "Development",
    "Duration of the internship (Months)":
      "2-3 months | Interns can start immediately",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.edgyscribblers.com",
    "Any expectations from the intern?":
      "Intern should have the Zeal to learn, and have adaptability. We won�t be spoon feeding things, the intern would be given the guidance and basic understanding of topics, but for implementation and in-depth understanding the intern would have to put in efforts.",
    "Internship Description/Internship Posting Link":
      "The internship would include development of landing pages, enhancing UI/UX, building wordpress pages/websites, and also align the existing pages as per the SEO guidelines.",
    "Contact details for the opportunity(Email)": "pulkit@edgyscribblers.com",
    "Anything else you'd like to share?":
      "The internship can translate to a full-time opportunity, if the candidate works at par and is able to meet all the deadlines and reflects the behaviour of a team player and ability to learn, and implement quickly.",
  },
  {
    Timestamp: "03/31/2020 07:44:41",
    "Company Name": "Edgy Scribblers",
    "Internship Domain": "UI/UX and graphics",
    "Duration of the internship (Months)": "2-3 months | Can start immediately",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.edgyscribblers.com",
    "Any expectations from the intern?":
      "The intern should have a good understanding of Photoshop, Illustrator, HTML5, CSS, and Javascript.",
    "Internship Description/Internship Posting Link":
      "The candidate will be responsible for managing the design aesthetics of our upcoming landing pages, emails, and other graphical work. At the same time, he/she should be able to implement the same on UI/UX front.",
    "Contact details for the opportunity(Email)": "pulkit@edgyscribblers.com",
    "Anything else you'd like to share?":
      "The opportunity can translate into a full-time job.",
  },
  {
    Timestamp: "03/31/2020 07:58:17",
    "Company Name": "Femme First Foundation",
    "Internship Domain": "Non-Profit Organization",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "femmefirst.in",
    "Any expectations from the intern?":
      "> Structured interviews - Conduct, transcribe, and summarise interviews with identified individuals for research, planning, and content creation\n> Content Creation - Create inspirational, informative, and engaging content for all digital platforms of the organization",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "aa@femmefirst.in",
    "Anything else you'd like to share?":
      "Emails without CV & cover letter won't be entertained.",
  },
  {
    Timestamp: "03/31/2020 08:03:36",
    "Company Name": "Orgzit.com",
    "Internship Domain": "Content writing, digital marketing",
    "Duration of the internship (Months)": "6 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.orgzit.com",
    "Any expectations from the intern?": "Technical content writing",
    "Internship Description/Internship Posting Link":
      "Technical content writing internships for software product company",
    "Contact details for the opportunity(Email)": "parul@orgzit.com",
    "Anything else you'd like to share?":
      "Paid internships INR 5k per month for work from home internships.",
  },
  {
    Timestamp: "03/31/2020 08:44:49",
    "Company Name": "Shri Krishan Nitin Kumar Merchant Private Limted",
    "Internship Domain": "Branding",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.sknk155.com",
    "Any expectations from the intern?": "Self starter,design student prefered",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "8530303062",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 08:52:16",
    "Company Name": "JupIITer-The IIT-JEE & NEET Guru",
    "Internship Domain": "Training & Coaching",
    "Duration of the internship (Months)": "2nd April",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.jupiiter.in",
    "Any expectations from the intern?":
      "Experience in teaching class XI,XII Maths/Phy/Chem/Bio",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "niveditha.peddi13@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 10:05:37",
    "Company Name": "YouWe Pods",
    "Internship Domain": "Collecting data, market study, customer view",
    "Duration of the internship (Months)":
      "1 Can go longer depending on performance",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Experience in marketing, market research, if not anything then enthusiasm to leaen",
    "Internship Description/Internship Posting Link":
      "Product- Nap pods to be placed at hospitals, airports, offices to solve the problem of having to sleep on chairs/ benches. This is the research, market testing stage. You get to learn on how to start a profitable business from scratch and validate your idea. An experience which can come handy in many places.",
    "Contact details for the opportunity(Email)": "yuvikagupta10@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "03/31/2020 10:08:51",
    "Company Name": "The YouWe Talk Show",
    "Internship Domain":
      "Communication, coordination, contacting, raising sponsorship",
    "Duration of the internship (Months)": "1",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "Organised, creative, enthusiastic",
    "Internship Description/Internship Posting Link":
      "The YouWe show with Yuvika is produced, editing pending. It needs to go on an OTT channel, the work for which will be done by a problem solver who loves to sell. And further raise sponsorship money from MNCs.",
    "Contact details for the opportunity(Email)": "yuvikagupta10@gmail.com",
    "Anything else you'd like to share?":
      "This could be a part time internship so the intern is free to engage in other work.",
  },
  {
    Timestamp: "03/31/2020 10:14:29",
    "Company Name": "KVG & Co. Audit firm",
    "Internship Domain":
      "Finding human resources- election campaigner, marketing agency, personal assistant, operations head etc., shortlisting and closing the deal",
    "Duration of the internship (Months)": "1-3 depending on performance",
    "Are you open to on-board remote interns?": "No",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Finding Human resources, knowledge of various job portals, motivated to take complete responsibility",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)":
      "yuvikagupta10@gmail.com, vkgupta2004@yahoo.co.in, preyanshigupta@gmail.com",
    "Anything else you'd like to share?":
      "KVG is a 30+ yo firm with a new hot topic wing- Insolvency.",
  },
  {
    Timestamp: "03/31/2020 11:53:22",
    "Company Name": "PRISTYN CARE",
    "Internship Domain": "FINANCE",
    "Duration of the internship (Months)": "3",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "www.pristyncare.com",
    "Any expectations from the intern?":
      "Excel, Basic Finance, Problem Solving",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)":
      "ankit.mangla@pristyncare.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 01:41:30",
    "Company Name": "Gordian Technologies Private Limited",
    "Internship Domain": "UX UI Designer",
    "Duration of the internship (Months)": "2-3 Months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.gordian.in/",
    "Any expectations from the intern?":
      "Great design thinking\nHands on experience with WIX(Preferable)\nPhotoshop and After effects",
    "Internship Description/Internship Posting Link":
      "We are looking for interns who can understand the ethos of the company and translate that into all facets of the company. It includes the landing page, Admin/Customer dashboard and the design for the product.",
    "Contact details for the opportunity(Email)": "prajwal@gordian.in",
    "Anything else you'd like to share?":
      "We are a startup with a patent-pending product to change the way hyper-local deliveries are undertaken. We are here to disrupt, would love it if you can be a part of the movement.",
  },
  {
    Timestamp: "04/01/2020 01:54:26",
    "Company Name": "Gordian Technologies Private Limited",
    "Internship Domain": "Marketing and Business Development",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.gordian.in/",
    "Any expectations from the intern?":
      "Great communication skills, out of the box thinking and creative ideas.\nFamiliarity with tools like Microsoft Powerpoint, Wix is a plus.",
    "Internship Description/Internship Posting Link":
      "Internship would entail reaching out to potential customers using tools such as Tracxn and LinkedIn. Preparing customised decks for each class of customers and aggressive social media campaigning.",
    "Contact details for the opportunity(Email)": "prajwal@gordian.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 11:29:40",
    "Company Name": "NPR Design",
    "Internship Domain": "Digital Marketing",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.nprdesign.com",
    "Any expectations from the intern?": "Digital Media Buying & PPC",
    "Internship Description/Internship Posting Link": "No.",
    "Contact details for the opportunity(Email)": "nitinpr@nprdesign.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/01/2020 13:13:28",
    "Company Name": "Nagrika",
    "Internship Domain": "Urban Policy and Governance/Knowledge and Research",
    "Duration of the internship (Months)": "3-6 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.nagrika.org",
    "Any expectations from the intern?":
      "Graphic Design, Architecture, Urban Planning, Public Policy, Law, Social Science. Other relevant field based on individual merit/experience",
    "Internship Description/Internship Posting Link":
      "http://www.nagrika.org/careers",
    "Contact details for the opportunity(Email)": "info@nagrika.org",
    "Anything else you'd like to share?":
      "Looking for driven and passionate individuals looking to contribute towards a  who will be self-starters for remote work. Would require to have laptops and good internet connections.",
  },
  {
    Timestamp: "04/01/2020 16:13:04",
    "Company Name": "Surichi Foods And Agri Products LLP",
    "Internship Domain": "Marketing",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "Marketing Strategy, Digital Plan",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "grow.yourself@honeytub.com",
    "Anything else you'd like to share?":
      "Interested intern should share a short write up on why they are interested in marketing and right fit for this internship along with their resume on the given email ID",
  },
  {
    Timestamp: "04/01/2020 16:14:34",
    "Company Name": "HoneyTub",
    "Internship Domain": "Design",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "Designing social media creatives",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "grow.yourself@honeytub.com",
    "Anything else you'd like to share?":
      "please send link to the portfolio on the mentioned email ID",
  },
  {
    Timestamp: "04/01/2020 18:46:20",
    "Company Name": "Rocketium",
    "Internship Domain": "Marketing, Sales, Product Management",
    "Duration of the internship (Months)": "2-6 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://rocketium.com",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "anurag@rocketium.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 11:22:29",
    "Company Name": "Sportifan",
    "Internship Domain": "Finance Intern",
    "Duration of the internship (Months)": "8 Weeks",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://media-exp1.licdn.com/dms/image/C5122AQHh7GHNY_-BQw/feedshare-shrink_1280/0?e=1588809600&v=beta&t=H_dgGsyeVBbTfx0EIF-uCBPyWCpa80KTRr4FhgWxLLI",
    "Contact details for the opportunity(Email)": "info@sportifan.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 11:46:36",
    "Company Name": "Centre for Science and Environment",
    "Internship Domain": "esearch based and non research based.",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.cseindia.org/internship-at-cse-1392",
    "Contact details for the opportunity(Email)": "dpriyanka@cseindia.org",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 12:12:08",
    "Company Name": "InvestMitra",
    "Internship Domain": "Business Development",
    "Duration of the internship (Months)": "2 to 3 Months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.investmitra.com",
    "Any expectations from the intern?": "Sales / Marketing Skillset",
    "Internship Description/Internship Posting Link": "Send an email to us",
    "Contact details for the opportunity(Email)": "hr@investmitra.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 13:39:49",
    "Company Name": "Incampus Ltd",
    "Internship Domain":
      "Marketing, HR, product management, content creation, product  design",
    "Duration of the internship (Months)": "2-3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.incampus.me",
    "Any expectations from the intern?": "Passion, open to learn and develop",
    "Internship Description/Internship Posting Link":
      "Internship, live projects",
    "Contact details for the opportunity(Email)": "incampus@incampus.me",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/03/2020 15:32:32",
    "Company Name": "CHRO Nexus",
    "Internship Domain": "All",
    "Duration of the internship (Months)": "8 weeks",
    "Are you open to on-board remote interns?": "varun.alagati@gmail.com",
    "Website of the company": "Google CHRO Nexus",
    "Any expectations from the intern?": "NA",
    "Internship Description/Internship Posting Link": "Linkedin",
    "Contact details for the opportunity(Email)": "varun.alagati@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 07:57:21",
    "Company Name": "Sharechat",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/e/1FAIpQLSd8vYCGa0-g7VdNDAxGgN3vW9pmJQirW7aAZ701_mWETfFgSg/viewform?fbzx=-115222589138398520",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 07:59:50",
    "Company Name": "The Atom",
    "Internship Domain": "Marketing, Product, Engineering, Design, Management",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://theatom.freshteam.com/jobs",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:02:01",
    "Company Name": "Fossasia",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "https://fossasia.org/",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/e/1FAIpQLScp8h5SIPVK5G2SAm5vtrv7KLKeOeYTxlZBkDRE6I7Toybt0A/viewform",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:06:03",
    "Company Name": "Foreign Admits",
    "Internship Domain": "Engineering, MBA, Humanities",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "\nDO ANSWER- Why do you want to join ForeignAdmits?\n#Engineering students with good coding skills and who can work on technologies- Full Stack, MEAN/ MERN Stack, Android & iOS, Software Dev.\n\nMBA's students with a knack for national & international Sales & Marketing are preferred.\n(Not Preferred- Stipend Driven Individual)\n\nDesign, Arts, Journalism, Media & Mass communication students can apply for graphics, video production & content roles.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "nikhil@foreignadmits.com",
    "Anything else you'd like to share?":
      "Get a chance to work with me personally & a few other folks who are experts in business & technology from the USA & Microsoft.\nGet a rigorous power-packed experience to create an impact on business & to leapfrog the growth in your profile.\n\nWe will work using Zoom, Google Docs, Slack, Git, WhatsApp, Airtable, etc.\n\nforeignadmits Team is well versed with remote working as we had been working remotely since inception & have helped and trained our team to work effectively & efficiently from any remote locations.\n\nPlus get to experience a sports team kind of environment in a global team.\n\nProcess for Evaluation- \nResume Evaluation + Task (2 days) + Interview (1-2 days)",
  },
  {
    Timestamp: "04/04/2020 08:06:55",
    "Company Name": "Google Summer of Code",
    "Internship Domain": "Engineering",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "https://summerofcode.withgoogle.com/",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:08:41",
    "Company Name": "TURNINGIDEAS VENTURES",
    "Internship Domain": "Investment Analyst Associate and Research Associate",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "turningideas.com",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "info@turningideas.com",
    "Anything else you'd like to share?":
      "\nWe will be teaching you basic Investment and evaluation skills ",
  },
  {
    Timestamp: "04/04/2020 08:09:18",
    "Company Name": "Internshala",
    "Internship Domain": "Internship Fair",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://internshala.com/the-grand-summer-internship-fair",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:10:20",
    "Company Name": "Fampay",
    "Internship Domain": "Graphic Designing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://jobs.lever.co/fampay/?location=Remote",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:13:14",
    "Company Name": "Apollo 247",
    "Internship Domain": "ops, product & financ",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "passionate about healthcare or tech",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "vs@apollo247.org",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:19:29",
    "Company Name": "",
    "Internship Domain": '"Category Launch"',
    "Duration of the internship (Months)":
      "2 months (Start date: 1 Apr or 1 May)",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Sports/Music/Theatre + Languages/Robotics",
    "Internship Description/Internship Posting Link":
      "Key skills required: National level representation/performance credentials in any activity in any one of the categories, good inter-personal skills, structured & rational thought process & strong work ethics/discipline.",
    "Contact details for the opportunity(Email)": "kapish@kid-ex.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:21:49",
    "Company Name": "Cloudflare",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "https://www.cloudflare.com/en-in/careers/jobs/",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://techcrunch.com/2020/04/02/cloudflare-ceo-pledges-to-double-2020-internship-class/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:26:16",
    "Company Name": "Edgistify",
    "Internship Domain": "Tech, Business Strategy, Sales, Operations",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/feed/update/urn:li:activity:6649583586561355776/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:29:44",
    "Company Name": "Codechef",
    "Internship Domain": "All verticals",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "building an equality driven platform through housing",
    "Contact details for the opportunity(Email)": "tanvi@letscove.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:31:08",
    "Company Name": "producthood",
    "Internship Domain": "Product management",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "producthood.com",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "lokesh@producthood.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:33:34",
    "Company Name": "Codechef",
    "Internship Domain": "Engineering primarily",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.codechef.com/careers",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:35:58",
    "Company Name": "Board Infinity",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/document/d/1MMewl2FMj8YcSV2FOCBPzB_bbemc16nSLCnWEJkHqzk/edit",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:38:33",
    "Company Name": "CleverTap",
    "Internship Domain": "Product Design",
    "Duration of the internship (Months)": "3/>3 months",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "clevertap.com",
    "Any expectations from the intern?":
      "You'll be working on brilliant projects and learning from really ambitious and driven people who are solving for #Retention for 8000+ customers. Your projects will go live and you'll learn the Product Development lifecycle from Inception to Pixel Perfect deliverable going into Production!\n\nPre-requisites:\n1. Must come from a background in Design / Technology.\n2. Must show significant chops in problem-solving, product design and the willingness to learn.\n3. Must be an internship equal to or more than 3 months' tenure.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "swapnil@clevertap.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:41:17",
    "Company Name": "Lazada",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "www.lazada.com",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.lazada.com/en/careers/job-search?category=00000219,00000227,00000220",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:41:59",
    "Company Name": "Shopee",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://boards.greenhouse.io/shopee?t=66d2e9722",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:47:55",
    "Company Name": "IIT Hyderabad",
    "Internship Domain": "Tech",
    "Duration of the internship (Months)": "8-10 weeks",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://cse.iith.ac.in/admissions/internships.html",
    "Contact details for the opportunity(Email)": "cse_internship@iith.ac.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:55:41",
    "Company Name": "Fyle",
    "Internship Domain": "Customer Success",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.fylehq.com/team/join#position",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 08:56:46",
    "Company Name": "Citi Bank",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://jobs.citi.com/job/-/-/287/15292712",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 09:01:13",
    "Company Name": "Outreachy",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.outreachy.org/apply/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 09:04:48",
    "Company Name": "Google",
    "Internship Domain": "Multiple",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://careers.google.com/students/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "https://www.businessinsider.com.au/googles-summer-internship-moves-to-a-virtual-format-for-2020-2020-3",
  },
  {
    Timestamp: "04/04/2020 09:09:45",
    "Company Name": "NIT Rourkela",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://eapplication.nitrkl.ac.in/internship/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 09:16:28",
    "Company Name": "Global Market Insights Research Pvt. Ltd",
    "Internship Domain": "MBA Students preferred",
    "Duration of the internship (Months)": "3months",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "gminsights.com",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "puja.sakhare@gminsights.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 09:18:50",
    "Company Name": "Pine Labs",
    "Internship Domain": "HR projects",
    "Duration of the internship (Months)": "2-3 months",
    "Are you open to on-board remote interns?": "Noida",
    "Website of the company": "https://www.pinelabs.com",
    "Any expectations from the intern?":
      "We are looking for energetic freshers with an interest to create an impact in people or talent related affairs. If you are pursuing Post Graduation from a Premium Institute, has good communication and analytical skills, and wish to start a career, then this is a great opportunity for you.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "careers@pinelabs.com",
    "Anything else you'd like to share?":
      "Subject Line as: \nHR_Intern_ (Highest Qualification) _(College)",
  },
  {
    Timestamp: "04/04/2020 09:21:31",
    "Company Name": "HappCoach",
    "Internship Domain":
      "Marketing, Strategy, Learning & Development & Content Writing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "If an internship with an E-learning startup across our platforms Happ Coach & StratGist excites you, do feel free to reach out directly to me",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "sorbo@happcoach.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 09:22:30",
    "Company Name": "Optobizz",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Eligible candidates: \n\nGood presentation skills\nBasic knowledge of Supply Chain Finance\nBasic knowledge of digital marketing\nPursuing or completed masters from Tier-I MBA institutes",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "raghava@optobizz.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 09:29:10",
    "Company Name": "Emproto Technologies",
    "Internship Domain": "Product Management Intern, Product Marketing Intern",
    "Duration of the internship (Months)": "2 months",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "emproto.com",
    "Any expectations from the intern?":
      "Product Management Intern\n-Understand the scope of Product\n-Talk to PMs/Engg Managers across similar SaaS companies and Target customers to get feedback\n-Work with design & development team to make sure the feedback is incorporated\n-Coordinate with Product Marketing team and come up with a GTM Plan\nWork on Marketing collaterals - Linkedin pages, blog articles\nDesign landing pages, set up Demos with prospective clients\n\nProduct Marketing Intern\n-Understand the scope of the Product\n- Understand the Product Marketing strategies adopted by competition\n-Work with the PM Team to come up with a Product Marketing strategy & execute on the same\n-Identify target accounts & set up demos",
    "Internship Description/Internship Posting Link":
      "Both interns will work in close coordination with the founders.",
    "Contact details for the opportunity(Email)":
      "Sneha@emproto.com\nRam@emproto.com",
    "Anything else you'd like to share?":
      "Emproto Technologies is an IIM Alumni venture focused on Product Development. We work with clients across the globe on Digital Transformation and New Product development initiatives. Some of them include Asian Paints, Titan, Philips Lighting etc. We are looking for enterprising interns to help us with the business activities over next 2 months.",
  },
  {
    Timestamp: "04/04/2020 09:32:48",
    "Company Name": "RoboManiax Edutech",
    "Internship Domain":
      "1). Research & Development - 10 positions. (R&D, Product Design & Content Development); 2). Business Development- 10 positions. (Sales & Marketing- Online)",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "hr@robomaniax.in",
    "Anything else you'd like to share?":
      "You should apply if: You are someone who speaks eloquently and clearly, Enjoy putting forth your point, Think on your feet and like learning new things, You are extra awesome! \nPerks: Certificate, Flexible WFHs, full-time PPO, Stipend.",
  },
  {
    Timestamp: "04/04/2020 09:36:29",
    "Company Name": "localsupply",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "Localsupply.in",
    "Any expectations from the intern?":
      "Volunteer Responsibilities:  Helping out hospitals reach suppliers and manufacturers who can meet the requirements Preparing weekly reports Preparing and submitting manufacturer-partnership contracts for orders Maintaining client records Answering client questions about terms, services, and availability",
    "Internship Description/Internship Posting Link":
      "Localsupply.in is a not for profit initiative started with an intention of providing hospitals, medical institutions, and health care personnel a centralized database of manufacturers, distributors, 3D printing organizations of various medical equipment�s required to successfully wage war on COVID-19. Sealing of the inter-state borders has become one of the biggest hindrances for this, leaving many lives at stake.  We already have strategic partnerships with DoctorC and WareIQ which helps you gain cross-domain expertise.",
    "Contact details for the opportunity(Email)": "admin@localsupply.in",
    "Anything else you'd like to share?":
      "What are we looking for?\n\nIn order to be successful in this role, you will have to be willing to help us onboard vendors and match them with the hospitals and medical institutions. All you have to bring is good interpersonal skills & your enthusiasm.",
  },
  {
    Timestamp: "04/04/2020 09:43:14",
    "Company Name": "Khelfit Wellness Private Limited",
    "Internship Domain": "Marketing & Strategy (Summer Internship)",
    "Duration of the internship (Months)": "2 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Project Details: Interns would be working on some/all of the below-mentioned areas as part of their internship. \n\nWhat are the underlying motivating factors for one to pursue fitness activities perpetually for different age groups and gender\nWhat are the underlying criteria for someone to accept virtual learning as an alternative to physical fitness centers?\nWhat are the kind of features in the fitness/primary preventive healthcare platform that one seeks to actively pursue their fitness regime\nAlternatives to substitute high-cost customer acquisition/awareness costs",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "info@khelfit.com",
    "Anything else you'd like to share?":
      "This position is open to only MBA 1st year students. Hence, kindly apply accordingly.",
  },
  {
    Timestamp: "04/04/2020 09:46:20",
    "Company Name": "Journey",
    "Internship Domain": "Web Development",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://angel.co/company/journeytogather",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 09:48:18",
    "Company Name": "Unschool Learning",
    "Internship Domain": "Marketing & Operations Intern",
    "Duration of the internship (Months)": "Business Development",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Criteria: Open to all.\n\nPreferring candidates who have worked in leadership roles in college fests and college organizations, with previous internship experiences.\n\nThe Job Role includes:\n\nWe want students inclined towards management. As a marketing intern, students will be trained and experiencing a wide variety of management portfolios including sales, marketing and business development.\n\nMarketing and promoting Unschool courses\nLeading a team of Campus Ambassadors across the country\nTraining and development of Ambassador teams\nAdvertising and branding the Unschool website and product",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "mourya@unschool.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 09:51:46",
    "Company Name": "Nutrizoe",
    "Internship Domain": "Marketing and Business Development",
    "Duration of the internship (Months)": "2-3 months",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "https://drive.google.com/drive/folders/1jkEZepvEifRZWHzwcub1XPymhX3iPUni",
  },
  {
    Timestamp: "04/04/2020 10:02:58",
    "Company Name": "Clear Tax",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://cleartax.in/s/career?ref=homepage-navbar-career",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 10:12:06",
    "Company Name": "JP Morgan Chase & Co.",
    "Internship Domain": "Software Engineering Virtual Experience",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.insidesherpa.com/virtual-internships/prototype/R5iK7HMxJGBgaSbvk/JP-Morgan-Banking-Technology-Virtual-Program",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 10:13:14",
    "Company Name": "KPMG",
    "Internship Domain": "KPMG Data Analytics Consulting Virtual Internship",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.insidesherpa.com/virtual-internships/theme/m7W4GMqeT3bh9Nb2c/KPMG-Data-Analytics-Virtual-Internship",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 10:15:58",
    "Company Name": "Ansys",
    "Internship Domain": "Software Development Intern",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "The Software Development Intern is responsible for researching and developing proof-of-concept prototypes for an enterprise simulation data and process management (SPDM) system. The system has a Web interface for accessing its features and there are many exciting possibilities for adopting rapid advances being made in the technology world in general and in Web technology world in specific, to improve the system. Examples include machine learning, rapid application development tools, etc. The job involves researching these new advances and developing software prototype(s) that demonstrate the benefits of using the advances in the SPDM system.",
    "Internship Description/Internship Posting Link":
      "https://careers.ansys.com/job/Pune-Software-Development-Intern-411007/623715700/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "RESPONSIBILITIES\n\n�Normal software development activities including understanding software feature requirements, design, coding, testing, feature demonstration, etc.\n\nMINIMUM QUALIFICATIONS\n\n�Candidates pursuing Bachelor of Engineering in Computer Science stream or equivalent\n\nPREFERRED QUALIFICATIONS\n\n�Students with prior programming experience in Web technologies will be preferred.",
  },
  {
    Timestamp: "04/04/2020 10:22:54",
    "Company Name": "Mistay",
    "Internship Domain": "Multiple",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "mistay.fastpad.com",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 10:24:52",
    "Company Name": "Eat My News",
    "Internship Domain": "Board of Young Leaders at EMN [Limited Slots]",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/e/1FAIpQLSdd0rFsf4bZPJIaS046sR8RQ7aW4tn3_1bFEn5LK6e8Glye_w/viewform",
    "Contact details for the opportunity(Email)": "Digital@EatMyNews.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 10:28:42",
    "Company Name": "squaresequel",
    "Internship Domain": "Digital Marketing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "squaresequel.com",
    "Any expectations from the intern?":
      "10 summer interns to work with us virtually from 1st April for two/three months in the digital marketing space.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "info@squaresequel.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 12:04:11",
    "Company Name": "Emproto Technologies",
    "Internship Domain": "Technology",
    "Duration of the internship (Months)": "2 Months +",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.emproto.com",
    "Any expectations from the intern?":
      "Good Problem solving skills. Solid Coding experience in any Tech stack (iOS/Android, Front end web - React/Angular, Backend - Node JS/Python/Java)",
    "Internship Description/Internship Posting Link":
      "Email to Sneha@emproto.com",
    "Contact details for the opportunity(Email)": "sneha@emproto.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 12:14:10",
    "Company Name": "hoppingrabbit",
    "Internship Domain": "Business Strategy, Product Marketing",
    "Duration of the internship (Months)": "Flexible",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "hoppingrabbit.in",
    "Any expectations from the intern?":
      "BUSINESS STRATEGY\nWhat you will do\n� Draw-up and implement growth strategy\n� Assess opportunities and identify threats\n� Generate insights through data, primary and secondary research\n� Work on different pitch decks\n� Work closely with founders in scaling up the business\nWhat we are looking for\n� Engineering + MBA from Tier 1/2 colleges\n� 0-2 years of work experience\n� Comfortable with numbers\n� Eagerness to learn and develop",
    "Internship Description/Internship Posting Link":
      "PRODUCT MARKETING What you will do � Participate in the creation of marketing plan/campaigns � Create Go-To-Market (GTM) strategy � Conduct market research and built comprehensive value proposition � Formulate customer acquisition strategy and generate leads � Create consistent positioning statements, messaging and the associated proof points What we are looking for � MBA from Tier 1/2 colleges � 0-2 years of work experience � Ability to Compose a Solid Presentation � Eagerness to learn and develop � Excellent written and verbal communication skills",
    "Contact details for the opportunity(Email)":
      "If you are from IIM A B C L, ISB or XLRI, register on hoppingrabbit.in and apply Or If you belong to other Business schools, mail us your resume on general@hoppingrabbit.in",
    "Anything else you'd like to share?":
      "What we are looking for\n� MBA from Tier 1/2 colleges\n� 0-2 years of work experience\n� Interns comfortable working from home",
  },
  {
    Timestamp: "04/04/2020 12:17:53",
    "Company Name": "Fair and Lovely Foundation",
    "Internship Domain": "Work From Home",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.fairandlovelyfoundation.in/en/sheroes-mars",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 12:22:36",
    "Company Name": "Adroit Financial Services Pvt. Ltd.",
    "Internship Domain": "",
    "Duration of the internship (Months)":
      "Minimum duration : 4 weeks  Maximum duration : 12 weeks",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "for students who want to work in the domain of financial markets, portfolio management & financial writing.",
    "Contact details for the opportunity(Email)": "pms@adroitfinancial.com",
    "Anything else you'd like to share?":
      "Since it is ONLY for those whose internship was cancelled in the past few days, applicants are required to send their internship cancellation letter (a picture from mobile is OK) along with CV/Resume on email.",
  },
  {
    Timestamp: "04/04/2020 13:31:56",
    "Company Name": "Global Alliance for Mass Entrepreneurs",
    "Internship Domain": "Research",
    "Duration of the internship (Months)": "2 weeks-1 month",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "http://massentrepreneurship.org/",
    "Any expectations from the intern?": "Good communication, research skills",
    "Internship Description/Internship Posting Link": "-",
    "Contact details for the opportunity(Email)":
      "leena@massentrepreneurship.org",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 14:34:33",
    "Company Name": "Easy education",
    "Internship Domain": "Content writing",
    "Duration of the internship (Months)": "3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "Na",
    "Any expectations from the intern?": "Strong English. Some SEO.",
    "Internship Description/Internship Posting Link":
      "Digital marketing strategy and content writing around education domain",
    "Contact details for the opportunity(Email)": "Shitijmalhotra@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:12:29",
    "Company Name": "Cleartax",
    "Internship Domain": "HR",
    "Duration of the internship (Months)": "2 months",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://cleartax.applytojob.com/apply/job_20180627120325_6LCGXM9W7TVXHXDQ/HR-Internship?source=LILI#nSVtXOA4PO",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:13:31",
    "Company Name": "Book My Show",
    "Internship Domain": "Social Media Marketing",
    "Duration of the internship (Months)": "6 months",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://in.bookmyshow.com/careers/job-view/trainee-social-media-marketing/?id=mp0qzic",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:14:09",
    "Company Name": "Mistay",
    "Internship Domain": "Operations Representative (Internship)",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://mistay.fastpad.com/opening/eb2d42bc-51e9-11e7-a41b-f32bc3316012/details",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:14:36",
    "Company Name": "Mistay",
    "Internship Domain": "HR Representative (Internship)",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://mistay.fastpad.com/opening/9c6b424c-7605-11e7-90ea-e76f84453415/details",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:15:03",
    "Company Name": "Citi",
    "Internship Domain": "Consumer Banking, 2020 Campus Summer Hire, India",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://jobs.citi.com/job/-/-/287/15173261",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:22:23",
    "Company Name": "Mobile Premier League",
    "Internship Domain": " Strategy, Marketing, Finance and Product",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "interns2020@mplgaming.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:32:21",
    "Company Name": "-Digitally Next, iMET Global & iSoCIAL Connect",
    "Internship Domain":
      "1. Marketing content  2. Digital/Social Media 3. Brand Communications 4. Community engagement 5. Data Analytics",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "careers@digitallynext.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:33:53",
    "Company Name": "Stealth mode Fintech,",
    "Internship Domain": "Product Management summer interns",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "1. Develop business cases and perform market analysis \n2. Develop BRD, Wireframes, MVP Launch and conduct User Analytics and reiterate \n3. Work on investment docs \n4. Self starter and ability to work on the projects. \n5. MBA and previous PM experience preferred \n6. Duration: 1/2 months\n7. Internship to start from 1st week of April.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "Anshul_g22@yahoo.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/04/2020 16:38:35",
    "Company Name": "GlobalGyan Academy of Management Education",
    "Internship Domain": " sales, marketing and content",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "globalgyan.in",
    "Any expectations from the intern?":
      'Just a small note to those who have sent us emails, and those who might want to.... An internship might be a requirement for your course, it is not an obligation for the corporate. If you are going to send an email that you have sent to hundred others, without bothering to connect with the company/person you are addressing, why should anyone select you? Don\'t tell me what you want; share what you have to offer us. And... "Hey team" is not the best way to start your email requesting an internship.',
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "careers@globalgyan.in",
    "Anything else you'd like to share?":
      "Do send in your resume to careers@globalgyan.in with a brief note on how you can help GlobalGyan Academy of Management Education this summer.",
  },
  {
    Timestamp: "04/05/2020 05:48:04",
    "Company Name": "Chegg India",
    "Internship Domain": "Marketing interns",
    "Duration of the internship (Months)": "2 months",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.way2fresher.com/job/chegg-india-hiring-marketing-interns-for-a-short-period/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 05:50:52",
    "Company Name": "Speck Products",
    "Internship Domain": "Web Designer / Developer Intern",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "San Mateo, CA",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://speckproducts.theresumator.com/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 06:47:00",
    "Company Name": "Baidu USA",
    "Internship Domain": "Research Intern-  Cognitive Computing Lab (CCL-US)",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Highly motivated PhD students are invited to submit applications for Research Intern positions in the Cognitive Computing Lab (CCL-US) at Baidu Research. We have offices in both Sunnyvale, CA and Bellevue, WA. Openings are available throughout the year, although typically fully-time interns work during the summer. Part-time internships can also be arranged.\n\nApplicants should be pursuing doctoral degrees in Computer Science, Statistics, Electrical Engineering, or related fields. Research interns will be conducting original basic research which ideally will lead to publications in premier venues. Areas of research include statistical learning, deep learning, natural language processing/understanding, computer vision, theoretical computer science, privacy, etc.",
    "Internship Description/Internship Posting Link": "ccl-job@baidu.com",
    "Contact details for the opportunity(Email)": "ccl-job@baidu.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 06:50:43",
    "Company Name": "BiLFINGER",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.bilfinger.com/en/careers/overview/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 06:52:57",
    "Company Name": "Mahle",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.jobs.mahle.com/india/en/jobs/?entry_level=Praktikum&entry_level=Werkstudententaetigkeit&country=all&page=4",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/05/2020 11:51:02",
    "Company Name": "Legodesk",
    "Internship Domain": "Business Development",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.legodesk.com",
    "Any expectations from the intern?":
      "We are looking for interns with at least a year experience in any domain.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "reach@legodesk.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 17:25:05",
    "Company Name": "",
    "Internship Domain": "Sales and marketing",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "",
    "Any expectations from the intern?": "Certificate",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)":
      "abhishek.kbhopal19-21@iiebm.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:02:54",
    "Company Name": "",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://mbafcpa.com/careers/college-students/",
    "Contact details for the opportunity(Email)": "careers@life.church",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:03:32",
    "Company Name": "Thomson Reuters",
    "Internship Domain": "Marketing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "Marketing Summer 2020 Internship",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:04:01",
    "Company Name": "WestRock",
    "Internship Domain": "Manufacturing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "Early Career Manufacturing Intern",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:04:48",
    "Company Name": "Thales",
    "Internship Domain": "Electrical Engineering Summer Intern",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "careers@thalesdsi.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:05:42",
    "Company Name": "McKim & Creed",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://mckimcreed-openhire.silkroad.com/epostings/index.cfm",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:09:05",
    "Company Name": "",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.obsidiansecurity.com/careers/",
    "Contact details for the opportunity(Email)": "apply@obsidiansecurity.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:09:48",
    "Company Name": "Taylor Design",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://jobs.wearetaylor.com/design-intern/job/12364614",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:10:29",
    "Company Name": "Baidu USA",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "http://usa.baidu.com/careers/",
    "Contact details for the opportunity(Email)": "intlcomm@baidu.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:10:54",
    "Company Name": "",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.mcdermott.com/Careers/Students-and-Graduates/Summer-Internship-Program",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:11:35",
    "Company Name": "Freese and Nichols",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://workforcenow.adp.com/mascsr/default/mdf/recruitment/recruitment.html?cid=11250fb5-ab52-424b-a203-98ab7750a6a4&ccId=685417109_3909&type=MP&lang=en_US",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:15:49",
    "Company Name": "KSA",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://ksaeng.hua.hrsmart.com/hr/ats/JobSearch/viewAll",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:16:07",
    "Company Name": "REGENXBIO",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://recruiting.ultipro.com/REG1004RGXI/JobBoard/c3499c89-5822-404b-8c79-23508f53953f/OpportunityDetail?opportunityId=e263c90a-33ed-4276-a692-c3278c42e4a7",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:16:33",
    "Company Name": "Brown Gibbons Lang & Company",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "Investment Banking Internship",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:17:09",
    "Company Name": "Valkyrie Trading",
    "Internship Domain": "Software Engineer Intern",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.valkyrietrading.com/careers/",
    "Contact details for the opportunity(Email)": "hello@valkyrietrading.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:21:38",
    "Company Name": "Brown Gibbons Lang & Company",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.bglco.com/careers/view-open-positions/",
    "Contact details for the opportunity(Email)": "recruiting@bglco.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:22:03",
    "Company Name": "AIMIA",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://aimia.wd3.myworkdayjobs.com/aimia_career_site/0/refreshFacet/318c8bb6f553100021d223d9780d30be",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:22:43",
    "Company Name": "pulse secure",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.pulsesecure.net/careers/job-listings/",
    "Contact details for the opportunity(Email)": "careers@pulsesecure.net",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:23:04",
    "Company Name": "Deutsche Bank",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.db.com/careers/en/grad/role-search/entry-level.html",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:23:54",
    "Company Name": "Visual BI",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://visualbi.com/careers/",
    "Contact details for the opportunity(Email)": "solutions@visualbi.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 18:24:57",
    "Company Name": "HKS",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://hksinc.wd5.myworkdayjobs.com/HKSStudent",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/06/2020 19:15:15",
    "Company Name": "book my show",
    "Internship Domain":
      "To work in an organization offering high degree of challenge, responsibilities and decisions making power where I can use my skills to achieve the organizational Goals",
    "Duration of the internship (Months)": "3 month",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company":
      "https://in.bookmyshow.com/careers/job-view/trainee-social-media-marketing/?id=mp0qzic",
    "Any expectations from the intern?":
      "Internships are an excellent way for you to gain real word experience, network with potential future coworkers and managers, and are an excellent way for you to build your resume and ultimately help lay the groundwork you�ll need to build the future of your own career.",
    "Internship Description/Internship Posting Link":
      "It should be short paragraph what are your career aspirations and why you are keen on taking up the internship. Keep it short and more focused on the type of internship that you are applying for. Best way to highlight your key skills by together in bullet points and highlighting your strengths and personal skills.",
    "Contact details for the opportunity(Email)": "mayurzalwar123@gmail.com",
    "Anything else you'd like to share?":
      "To work in an organization offering high degree of challenge, responsibilities and decisions making power where I can use my skills to achieve the organizational Goals",
  },
  {
    Timestamp: "04/07/2020 07:25:02",
    "Company Name": "Gyaanspace.com",
    "Internship Domain":
      "Trivia/quiz question writer, content writer for social mediaw, digital marketing, graphic designer, business development",
    "Duration of the internship (Months)": "One month to three months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "Gyaanspace.com",
    "Any expectations from the intern?":
      "Good in English, has curiosity to do quality research, good with short form content and social media management.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "kunal@gyaanspace.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 10:46:53",
    "Company Name": "Titan Capital",
    "Internship Domain": "Tech Internship",
    "Duration of the internship (Months)":
      "12 Month-- Part Time-- Work from home",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "titancapital.vc",
    "Any expectations from the intern?":
      "Should be skilled and passionate about tech/coding and willing to see quick business output of their tech work. Not needed to be from computer science just you should know good coding and passionate about building products and see real time impact.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "abhishek@titancapital.vc",
    "Anything else you'd like to share?":
      "Should be pre-final year undergraduate student from top tier university in NCR as we are Gurgaon based and weekly day long meetings/lunch get together with team would be required for efficient coordination.",
  },
  {
    Timestamp: "04/07/2020 10:57:05",
    "Company Name": "Salt",
    "Internship Domain":
      "Product Management, Android Development, Backend development, frontend development, Content/Social Media, Graphic Designer, UX/UI Designer",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "udita@salt.pe",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 11:11:54",
    "Company Name": "WhiteHat Jr",
    "Internship Domain": "Growth/Analytics Intern",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "We're also looking for growth/analytics MBA interns--incase your internship has been put on hold.",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/e/1FAIpQLSdtbvcpOGW6HpyGtsKK3X9T3jcN-soF5_ZeejfUQvyjq8gyUg/viewform",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "WhiteHat Jr is hiring strong folks full-time in nearly every function, product, tech, sales and operations, for immediate remote joining amidst the lockdown.",
  },
  {
    Timestamp: "04/07/2020 11:35:01",
    "Company Name": "BugendaiTech",
    "Internship Domain": "Data Science, Software Development",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "hr@bugendaitech.com",
    "Anything else you'd like to share?":
      "BugendaiTech is looking for interns who are passionate about data science and want to help drive business results. You will be working in a fast-paced environment on a number of projects where you will be responsible for processing large volumes of data to find insights.\n\nWe are also looking for a number of intelligent, hard-working, team-oriented Graduate Student interns who enjoy developing professional software.",
  },
  {
    Timestamp: "04/07/2020 11:42:41",
    "Company Name": "PURPLETRADES",
    "Internship Domain":
      "react or python or DB management or front end development",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "kushaljain@purpletrades.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 11:43:51",
    "Company Name": "follege",
    "Internship Domain":
      "content, social media marketing, community management",
    "Duration of the internship (Months)": "atleast 1 monh",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "http://follege.com (view on web only)",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/posts/abhinav-singh-090b8aa4_internship-connections-opportunity-activity-6653155568318017537-r3tA",
    "Contact details for the opportunity(Email)": "follegeapp@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 11:46:59",
    "Company Name": "HealthReflect",
    "Internship Domain":
      "computer science, marketing, sales & design background",
    "Duration of the internship (Months)": "3-5 months",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "careers@healthreflect.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 11:56:51",
    "Company Name": "Blueline Computers",
    "Internship Domain": "Website Developer",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.bluelinecomputers.com/career.html",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 12:06:19",
    "Company Name": "Follege",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://follege.com/Apply",
    "Contact details for the opportunity(Email)": "follegeapp@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 12:21:06",
    "Company Name": "LetsEndorse",
    "Internship Domain": "business/economics?/engineering/social sciences? ?",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.letsendorse.com/",
    "Any expectations from the intern?":
      "We are looking for those who possess a strong entrepreneurial spirit and ?who can add enormous value to some of our ongoing projects in the areas of livelihoods and income generation, ecosystem building, enhancing technology capabilities of last-mile social workers, education, among others.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "?team@letsendorse.com",
    "Anything else you'd like to share?":
      "Send email with resume and ?the ?subject ?line?- LetsEndorse<>?YourName: ?Application for ?Summer Internship 2020",
  },
  {
    Timestamp: "04/07/2020 12:28:04",
    "Company Name": "Byjus",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://byjus.com/careers-at-byjus/",
    "Contact details for the opportunity(Email)": "recruitments@byjus.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 12:32:32",
    "Company Name": "lloydharrington",
    "Internship Domain": "6",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "http://www.lloydharrington.com.au/",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "info@lloydharrington.com.au",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 13:23:11",
    "Company Name": "Myraa Technologies",
    "Internship Domain": "Software Development",
    "Duration of the internship (Months)": "6",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "Www.myraatechnologies.com",
    "Any expectations from the intern?": "Python html Css javascript",
    "Internship Description/Internship Posting Link":
      "https://internshala.com/internship/detail/full-stack-development-internship-in-navi-mumbai-mangalore-at-myraa-technologies1585224128",
    "Contact details for the opportunity(Email)": "hello@myraatechnoligies.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 13:32:35",
    "Company Name": "Codevidhya",
    "Internship Domain": "Content Development",
    "Duration of the internship (Months)":
      "Till June end, extendabele, can be converted to full time job.",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.codevidhya.com",
    "Any expectations from the intern?":
      "Knowledge about Programming Languages\n\nWe are looking for a Curriculum Content Developer and Designer for Computer Science (Coding) subject from Grade 1 to 10. The curriculum Designer�s responsibilities include creating detailed, engaging curriculum and quality resources. You should be passionate about learning and aware of how digital technology has reshaped education. You should have excellent technical writing, research, and communication skills. Selected candidate will be responsible for grade wise content outlines, preparing detailed interactive content, examples, assessments, training modules, teachers manual etc.",
    "Internship Description/Internship Posting Link":
      "Job Responsibilities: �        Conduct research and develop quality curricula and learning resources. �        Create stimulating lesson plans and recommend interesting additional resources. �        Develop a range of digital resources to optimize classroom learning. �        Write engaging content that allows learners to meet their learning goals �        Visualize and conceptualize graphics that suit the target audience �        Create high-quality assessment questions for evaluating students� skills �        Create supplementary teacher and student guides, as well as resource packs. �        Collaborate with other writers, graphic designer, and web designers to create new learning resources. �        Create tests, exams and other formal and informal assessments to gauge the effectiveness of curriculum.  Skills Desired: �",
    "Contact details for the opportunity(Email)": "poorvi@codevidhya.com",
    "Anything else you'd like to share?":
      "Possibly need interns who can relocate to Jaipur\n\n   Degree in Education and having excellent knowledge of HTML, CSS, JavaScript, Python, AI, ML, IoT and DBMS. �        Computer Science / IT teaching experience will add advantages �        Master�s degree preferable �        Excellent collaboration, and written and verbal communication skills. �        Willingness to learn new skills �        Strong digital and research skills. �        Strong planning skills, vision, creative intelligence.",
  },
  {
    Timestamp: "04/07/2020 13:35:10",
    "Company Name": "Codevidhya",
    "Internship Domain": "Trainer",
    "Duration of the internship (Months)":
      "Till June end, extendable, can be converted to full time job.",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.codevidhya.com",
    "Any expectations from the intern?": "Knowledge of Programming Languages",
    "Internship Description/Internship Posting Link":
      "We are looking for talented, dynamic and motivated individuals with a passion for teaching &  training  to become part of our training team for immediate joining.  Responsibilities and Duties: �        Facilitate learning for programming concepts & emerging technologies to teachers & school students. �        Deliver Training sessions in accordance with the designated module/program, strategies & guidelines. �        Explain, guide, mentor and engage students & teachers to reach their highest potential. �         Development of ideas into projects in the field of Computer Science. �         Handle each trainee with utter care and responsibility. �        Willingness to travel at short notice. Required Experience and Qualifications: Graduates with Computer Science background, , having experience in mechanical and electronic field other streams can also apply if having any interest & expertise in this field. �        Having excellent knowledge of Programming concepts like HTML, CSS, JavaScript, Python and MySQL and emerging technologies like Robotics, Raspberry Pi, IoT, AI, ML . �        Capable of developing metrics to assess the benefits of training and provide reports to stakeholders on progress against training objectives. �        Teaching & Training experience in Computer Science / IT  will be an added advantage. �        Good communication with fluency in spoken and written English. �        Technically inclined & Willing to learn new skills and aid students & teachers in the same. �        Good analytical and debugging skills. �        Community-oriented and passionate in developing student & teacher community.",
    "Contact details for the opportunity(Email)": "poorvi@codevidhya.com",
    "Anything else you'd like to share?":
      "Possibly need interns who can relocate to Jaipur.",
  },
  {
    Timestamp: "04/07/2020 14:57:24",
    "Company Name": "",
    "Internship Domain": "Marketing",
    "Duration of the internship (Months)": "3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/07/2020 19:38:05",
    "Company Name": "Red Dot Foundation - Safecity",
    "Internship Domain": "https://safecity.in/volunteer-activities/",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.safecity.in",
    "Any expectations from the intern?": "Depends upon the profile",
    "Internship Description/Internship Posting Link":
      "1. Data Analysis, 2. Video making, 3. Report Writing 4. Social Media Management",
    "Contact details for the opportunity(Email)":
      "vanshika@reddotfoundation.org",
    "Anything else you'd like to share?":
      "If anyone is interested in any of the profiles they can mail their CVs on vanshika@reddotfoundation.org",
  },
  {
    Timestamp: "04/07/2020 22:55:24",
    "Company Name": "Dolphinq",
    "Internship Domain": "Software Development",
    "Duration of the internship (Months)": "2-4 months Joining- ASAP",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Python, MATLAB\nInterested in working on breakthrough Brain imaging Technology",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)":
      "nitishsrivastava.com@gmail.com",
    "Anything else you'd like to share?":
      "Get an opportunity to work with the smartest people from different industries and work on cutting edge tech. Also an opportunity to work directly with the core team of the startup.",
  },
  {
    Timestamp: "04/07/2020 23:54:44",
    "Company Name": "LIVYGO TECHNOLOGIES",
    "Internship Domain": "Sales, business development.",
    "Duration of the internship (Months)": "2 or 3 Months",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "www.livygo.com",
    "Any expectations from the intern?": "None",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "Info@livygo.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 01:11:47",
    "Company Name": "amazon.com",
    "Internship Domain": "operations",
    "Duration of the internship (Months)": "90 days",
    "Are you open to on-board remote interns?": "No",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 01:30:27",
    "Company Name": "Sapio Analytics",
    "Internship Domain": "Data Analyst(Tech)",
    "Duration of the internship (Months)":
      "Immediate (2-6 months) | Open to full time hiring",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.sapioanalytics.com/",
    "Any expectations from the intern?":
      "Experience of working with python and R for data analysis(preferably machine learning and dashboards)",
    "Internship Description/Internship Posting Link": "Data Analyst",
    "Contact details for the opportunity(Email)":
      "Hr@sapioanalytics.com | arpit@sapioanalytics.com",
    "Anything else you'd like to share?":
      "You can go through the projects we are working on with the governments by going through our website",
  },
  {
    Timestamp: "04/08/2020 02:48:28",
    "Company Name": "Tap In",
    "Internship Domain": "Software/Product Development",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "Https://tapin.news",
    "Any expectations from the intern?": "iOS development is must!",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/posts/abeer-choubey_ios-android-iosdevelopers-activity-6652880937522651137-aN7l",
    "Contact details for the opportunity(Email)": "tapindev@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 04:18:28",
    "Company Name": "Teacherr",
    "Internship Domain": "Content and Community Intern",
    "Duration of the internship (Months)": "3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.teacherr.in",
    "Any expectations from the intern?":
      "1) Passionate about Education\n2) Good with analyzing data on  Excel \n3) Write quality content \n",
    "Internship Description/Internship Posting Link":
      "Please find the JD Below :   *Role* : Content and  Community Intern  *Location* - WFH  *Who are we? What do we do?* At Teacherr, we are trying to build an exclusive community for educators where educators can find jobs, connect with fellow educators, exchange ideas and resources and much more.  *Who are we looking for?*   We are hiring folks who are 1) Passionate about Education 2) Good with analyzing data on  Excel  3) Write quality content    *The Responsibilities and Duties include* -  1)Curating, growing and nurturing the  teacher Community 2)Identifying and solving problems in the community 3)Owning the engagement and success of our community 4)Interfacing with teams from product, growth and sales to align the community program perfectly with the business goals 5)Ad marketing and growth.",
    "Contact details for the opportunity(Email)": "varun@teacherr.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 05:48:30",
    "Company Name": "Framework",
    "Internship Domain": "Firmware Intern",
    "Duration of the internship (Months)":
      "We intend for this to be an on-site internship at our headquarters in Burlingame, California (and we'll provide an additional stipend to cover the stupidly expensive cost of living here). In the event travel or shelter-in-place restrictions are still ongoing in May/June, we will switch this over to being remote for as long as needed.",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Taking a firmware project from end-to-end on one of our products.\nCollaborating with electrical, software, and firmware engineers.\nImplementing real time embedded software running on microcontrollers.\nWriting test cases, tools, and documentation around your code.\nUpstreaming patches to open source software projects.",
    "Internship Description/Internship Posting Link":
      "https://jobs.lever.co/framework/a4598a78-1c5f-4f77-8333-2f38e76744da",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "A year or less away from graduating with a Bachelor's or Master's degree in Computer Science or Computer Engineering.\nFamiliarity with embedded systems and software development in C.\nSome experience with microcontroller-based development and debugging.\nA portfolio of software projects (from classwork, previous internships, and/or hobbies).\nA passion for design, DIY, and environmentalism.",
  },
  {
    Timestamp: "04/08/2020 05:49:48",
    "Company Name": "Framework",
    "Internship Domain": "Electrical Engineering Intern",
    "Duration of the internship (Months)":
      "We intend for this to be an on-site internship at our headquarters in Burlingame, California (and we'll provide an additional stipend to cover the stupidly expensive cost of living here). In the event travel or shelter-in-place restrictions are still ongoing in May/June, we will switch this over to being remote for as long as needed.",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Taking an electrical project from end-to-end on one of our products.\nCollaborating with electrical, mechanical, and firmware engineers.\nArchitecting electrical systems, selecting parts, designing schematics and layouts.\nBringing up evaluation boards and validating designs.\nDocumenting the system you designed.",
    "Internship Description/Internship Posting Link":
      "https://jobs.lever.co/framework/270a87d6-2c90-40f7-b467-535f62158cb1",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "A year or less away from graduating with a Bachelor's or Master's degree in Electrical or Computer Engineering.\nFamiliarity with embedded systems, microcontrollers, circuit design, and tools like oscilloscopes.\nSome experience with schematic capture and board layout.\nA portfolio of electrical engineering projects (from classwork, previous internships, and/or hobbies).\nA passion for design, DIY, and environmentalism.",
  },
  {
    Timestamp: "04/08/2020 05:52:45",
    "Company Name": "Cloudflare",
    "Internship Domain": "Multiple",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.cloudflare.com/careers/jobs/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "Type 'Intern' in the search box",
  },
  {
    Timestamp: "04/08/2020 06:01:46",
    "Company Name": "",
    "Internship Domain": "CS/EE major/Fine Arts",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "1) Machine Learning, preferably computer vision. \n2) Full Stack dev: front end (Angular/React) back end (AWS, sql). experience with unreal/unity desirable. \n3) Signal processing\nOR\nFine Arts major:\n1) Outgoing personality with necessary background for outreach to artists. Creative thinker and passionate about the arts.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "subham.sett@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 06:07:18",
    "Company Name": "Smartcourse",
    "Internship Domain":
      " business development, sales, marketing, operations, content, and product management efforts.",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Strong research and/or lead generation skills\n\nIn-depth understanding of social media marketing\n\nExcellent written/verbal communication skills\n\nComfortable continuously learning and working hard in a fast-paced and dynamic environment\n\nAbility to multi-task, prioritize, and manage time effectively",
    "Internship Description/Internship Posting Link":
      "https://smartcourse.freshteam.com/jobs/7tEgoDpwkYJf/smart-course-internship",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "Carving out a role for yourself based on your unique strengths and also helping wherever needed\n\nLearning everything you need to in order to provide the highest value add possible\n\nManaging pre-sales and post-sales operations\n\nFinding qualified prospects and gathering qualitative user data (demographics & psychographics) through immersive interviews\n\nPushing marketing materials on all social and email platforms\n\nDoubling down on your unique strengths to hone your skill set and help the company grow  ",
  },
  {
    Timestamp: "04/08/2020 06:19:05",
    "Company Name": "Pupil Mesh",
    "Internship Domain":
      "Sales and Marketing, Content Writing, Android development, Web development, Application development in Linux, Computer Vision/Image Processing, Internet of Things, 3D designing and 3D printing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "http://www.pupilmesh.com/#careers",
    "Contact details for the opportunity(Email)":
      "Email ids given on the same link",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 07:31:57",
    "Company Name": "Goldcast",
    "Internship Domain": "Software Development (Full Stack)",
    "Duration of the internship (Months)": "4 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://palashiitk.wixsite.com/goldcast",
    "Any expectations from the intern?":
      "Fullstack development experience, preferably from Computer Science, Electrical Engineering or Math background",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/e/1FAIpQLSfs-FFSK69tTbFLKFWaFUfl3HqJvnYOKVHTkTW6a-KzqV0vig/viewform",
    "Contact details for the opportunity(Email)": "psoni@mba2021.hbs.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 08:45:26",
    "Company Name": "Callido Learning",
    "Internship Domain":
      "Edtech company. Internships available in marketing, curriculum development, sales, data analytics, operations and more.",
    "Duration of the internship (Months)": "Minimum 2 months. All year round.",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.callidolearning.com",
    "Any expectations from the intern?": "Motivated. Strong communication.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "careers@callidolearning.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 09:07:38",
    "Company Name": "Analytic Steps",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.analyticssteps.com/career",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 09:09:17",
    "Company Name": "DTaiLabs",
    "Internship Domain":
      "1) Web Development             2) Artificial Intelligence",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "dtailabs.com",
    "Any expectations from the intern?":
      "Benefits:- \n1) Performance-based Rewards and Recognition. \n2) Real-time experience in Deep learning. \n3) working with Industry level experts in 'AI & WebDevelopement' Fields.\n4) Recognition from Industry professionals on LinkedIn which would help in better placements. \n5) Certificate after completion of the Internship. \n6) Opportunity to work on libraries on #TensorFlow,#Pytorch,#Fastai and many more. \n7)This will be a remote internship.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "raj.harry@dtailabs.com",
    "Anything else you'd like to share?":
      'Send your Resumes at "raj.harry@dtailabs.com" with a link to the work that you have already done and stated why you are fit for the above opportunity. *Limited Seats Only!!!*',
  },
  {
    Timestamp: "04/08/2020 09:17:03",
    "Company Name": "Foresiet",
    "Internship Domain": "Cybersecurity",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://media-exp1.licdn.com/dms/image/C5122AQHooW-lrEcS9A/feedshare-shrink_800/0?e=1589414400&v=beta&t=JLEZu1hA8S2ViiNG7ZsQBCkNpkrgshbdZN_noPbJiro",
    "Contact details for the opportunity(Email)": "info@foresiet.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 09:24:27",
    "Company Name": "Notarize",
    "Internship Domain": "finance & accounting intern",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Responsibilities include:\n- Assisting with weekly and monthly revenue and invoicing reconciliations\n- Partnering with the customer success team to ensure customer account payments are setup correctly\n- Responding to customer billing inquiries\n- Creating standard work around financial processes and identifying process improvements\n- Reviewing customer contracts in Salesforce and creating billing schedules",
    "Internship Description/Internship Posting Link":
      "Preferred qualifications: - Comfortable working in Excel - Moderate accounting knowledge - Attention to detail is critical - Ability to work both independently and collaboratively",
    "Contact details for the opportunity(Email)": "david.tran@notarize.com",
    "Anything else you'd like to share?":
      "Great opportunity for anyone looking to get some accounting experience at a rapidly growing startup. You'll get to work with me and our awesome VP of Finance.",
  },
  {
    Timestamp: "04/08/2020 10:53:14",
    "Company Name": "Women's Identity and Progress",
    "Internship Domain": "Research and Strategy",
    "Duration of the internship (Months)": "2 (Start asap)",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Research, analysis, passion for solving women's issues, interest in market oriented solutions, entrepreneurial energy",
    "Internship Description/Internship Posting Link":
      "Internship is about supporting the founder with research and intervention strategy",
    "Contact details for the opportunity(Email)": "outreach.wip@gmail.com",
    "Anything else you'd like to share?":
      "Please drop in a line on the above email ID for more details.",
  },
  {
    Timestamp: "04/08/2020 10:57:39",
    "Company Name": "Engendered",
    "Internship Domain": "Social media",
    "Duration of the internship (Months)": "Minimum 2, max upto the candidate",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.engendered.co",
    "Any expectations from the intern?":
      "Content writing, basic design, curiosity, showing initiative, discipline to work from home, interest in gender as a topic",
    "Internship Description/Internship Posting Link":
      "Looking for an unpaid social media intern to help us create content and organise content calendars. This includes thinking of campaign ideas, executing them and analysing metrics, creating a feedback loop.   This is a work from home internship with zoom e-meetings.   You will work with experienced individuals from the communication sector.   We will convert it to a paid role provided the performance is satisfactory for 3 weeks.",
    "Contact details for the opportunity(Email)": "pk@engendered.co",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 14:37:35",
    "Company Name": "Chanchal Handicrafts India LLP",
    "Internship Domain": "Operations, Social Media & Content Writing",
    "Duration of the internship (Months)": "3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.chanchal.co.in/",
    "Any expectations from the intern?":
      "Knowledge of MS Office, Writing skills and social media enthusiast",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "ethnicchanchal@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 16:16:08",
    "Company Name": "Womenite",
    "Internship Domain": "Non-profit",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "http://womenite.com/",
    "Any expectations from the intern?":
      "We are looking for people who are passionate to serve the community",
    "Internship Description/Internship Posting Link": "womenite.com/join-us/",
    "Contact details for the opportunity(Email)": "hr@womenite.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/08/2020 17:09:19",
    "Company Name": "Salt",
    "Internship Domain": "Product Management",
    "Duration of the internship (Months)": "2-6 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "salt.pe",
    "Any expectations from the intern?":
      "Responsibilities: \n- Understanding and analyzing user needs \n- Maintaining a deep understanding of the competitive landscape and trends \n- Validating and pitching new product ideas \n- Defining features through detailed specifications, user stories and wireframes - Working with design and engineering teams through feature implementations \n- Defining success metrics and analyzing product performance \n- Working with partners for customer success\n- Working with engineering team for the development & delivery",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/feed/update/urn:li:activity:6652859401730392064/",
    "Contact details for the opportunity(Email)": "udita@salt.pe",
    "Anything else you'd like to share?":
      "The following qualities are well-suited for this role: \n� Strong academic record \n� History of success in technical/analytical/engineering related tasks and roles \n� Previous internships and/or startup experiences \n� Motivated, self-starter with strong communication skills",
  },
  {
    Timestamp: "04/08/2020 19:24:42",
    "Company Name": "The Bombay Train Charter Company",
    "Internship Domain": "Marketing, Tech, Ops, Digital, Research, others",
    "Duration of the internship (Months)": "2-3 - short terms / Capstone (LTI)",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://bit.ly/TBTCC_Site",
    "Any expectations from the intern?":
      "functionally sound, ability to learn and deliver, committment, responsibility, leadership, etc.",
    "Internship Description/Internship Posting Link": "Open to discussion",
    "Contact details for the opportunity(Email)":
      "BombayTrainCharter@gmail.com",
    "Anything else you'd like to share?":
      "Promising students, get investor connect, choice of placements in ecosystem, pedigree support, etc.",
  },
  {
    Timestamp: "04/09/2020 03:05:50",
    "Company Name": "Penser",
    "Internship Domain":
      "Consulting, Business Analytics, Research, Data Analytics",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.penser.co.uk",
    "Any expectations from the intern?": "Research, analysis, communication,",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "victoria.smith@penser.co.uk",
    "Anything else you'd like to share?":
      "Penser is a London, UK based company company working with leading fintech companies globally",
  },
  {
    Timestamp: "04/09/2020 07:56:43",
    "Company Name": "Vardhan Consulting Engineers",
    "Internship Domain": "Finance.Management",
    "Duration of the internship (Months)": "2 Months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://techvardhan.com",
    "Any expectations from the intern?": "Masters Students Preferable",
    "Internship Description/Internship Posting Link":
      "https://techvardhan.com and Read Brochure",
    "Contact details for the opportunity(Email)": "hr@techvardhan.com",
    "Anything else you'd like to share?": "No Stipend",
  },
  {
    Timestamp: "04/09/2020 09:27:35",
    "Company Name": "Nexweave",
    "Internship Domain": "Design, Technology and Marketing",
    "Duration of the internship (Months)":
      "6 weeks to 6 months starting on 15th April 2020",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://nexweave.com",
    "Any expectations from the intern?":
      "Should be a Creative Problem Solver. Your degree is not as important as grit and wit when working with us.",
    "Internship Description/Internship Posting Link":
      "Check https://angel.co/company/nexweave",
    "Contact details for the opportunity(Email)": "connect@nexweave.com",
    "Anything else you'd like to share?":
      "We're happy to see candidates present an ideal job description of what they want to do at Nexweave. Hence we strongly urge them to get to know more about us before they decide to apply for our roles.",
  },
  {
    Timestamp: "04/09/2020 09:59:37",
    "Company Name": "book my show",
    "Internship Domain": "marketing",
    "Duration of the internship (Months)": "6 months",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company":
      "https://in.bookmyshow.com/careers/job-view/trainee-social-media-marketing/?id=mp0qzic",
    "Any expectations from the intern?":
      "Mastering Technical Skills. A good set of goals around technical business skills would be:",
    "Internship Description/Internship Posting Link":
      "Describe how the skills/experience will be valuable across your industry and what career it will prepare the intern for.",
    "Contact details for the opportunity(Email)": "mayurzalwar123@gmail.com",
    "Anything else you'd like to share?":
      "To work in an organization offering high degree of challenge, responsibilities and decisions making power where I can use my skills to achieve the organizational Goals",
  },
  {
    Timestamp: "04/09/2020 14:24:20",
    "Company Name": "EazyPG",
    "Internship Domain": "Telecalling",
    "Duration of the internship (Months)": "1 month Minimum",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "eazypg.in",
    "Any expectations from the intern?":
      "Needs to be good in communication skills as would be responsible for talking to customers who are already using EazyPG",
    "Internship Description/Internship Posting Link": "bit.ly/2x6xhV3",
    "Contact details for the opportunity(Email)": "kg@eazyapp.tech",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 15:56:55",
    "Company Name": "",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/09/2020 16:12:01",
    "Company Name": "TravClan",
    "Internship Domain": "https://lnkd.in/fpWaKb8",
    "Duration of the internship (Months)": "Immediate joining - 30th May 2020",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.travclan.com",
    "Any expectations from the intern?": "Prior experience in travel Industry",
    "Internship Description/Internship Posting Link":
      "https://drive.google.com/open?id=1EjE_2OT22GlDc3fJWYJBrjVpcoPorXbBCkPHOD7-4rE",
    "Contact details for the opportunity(Email)": "grow@travclan.com",
    "Anything else you'd like to share?": "NO",
  },
  {
    Timestamp: "04/09/2020 17:23:30",
    "Company Name": "ALOG TECH",
    "Internship Domain": "Robotics",
    "Duration of the internship (Months)": "3-6 months starting asap",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "www.alogtech.com",
    "Any expectations from the intern?":
      "1. Must have experience in ROS (robot operating system) and OpenCV\n2. Deep understanding of robotics concepts and algorithms\n3. Advanced coding skills in Python and C++\n4. Exposure to GPU and CUDA programming\n5. Completed relevant courses or online certifications",
    "Internship Description/Internship Posting Link": "ROS developer",
    "Contact details for the opportunity(Email)": "rn@alogtech.com",
    "Anything else you'd like to share?":
      "Selected intern's day-to-day responsibilities include:\n\n1. Work on algorithms for robot localization, path planning, motion control, and obstacle avoidance\n2. Work on development of new features\n3. Support demos and trials",
  },
  {
    Timestamp: "04/09/2020 19:43:38",
    "Company Name": "FORESIET TECHNOLOGY PRIVATE LIMITED",
    "Internship Domain": "ML/AI/Cyber Security",
    "Duration of the internship (Months)": "3/6/9",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "FORESIET.COM",
    "Any expectations from the intern?": "ML/AI/Data Scientist/Cyber Security",
    "Internship Description/Internship Posting Link":
      "We are looking highly energetic and passionate Intern ready to think out of the box while developing innovative cybersecurity solutions. Someone who understands ML/AI and looking to expand its reach within Cybersecurity vertical. As a professional, you may be one of the key contributors to our tech and product Team. Be assured that there will be a lot of learning.",
    "Contact details for the opportunity(Email)": "info@foresiet.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 03:13:13",
    "Company Name": "Danalitic",
    "Internship Domain":
      "Data Science and web development and graphic designing",
    "Duration of the internship (Months)": "3-4 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.danalitic.com",
    "Any expectations from the intern?": "Open to learn and can spent time.",
    "Internship Description/Internship Posting Link":
      "Good knowledge of Python programming along with distributed programming.",
    "Contact details for the opportunity(Email)": "agupta@danalitic.com",
    "Anything else you'd like to share?": "Na",
  },
  {
    Timestamp: "04/10/2020 09:57:16",
    "Company Name": "CashKaro.com",
    "Internship Domain": "Marketing & Growth",
    "Duration of the internship (Months)": "2 to 3 months (virtual)",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.cashkaro.com",
    "Any expectations from the intern?":
      "Ideal candidate should have the following skills:\n1. Energetic and very social\n2. Strong communication skills\n3. Strong marketing and sales interest and intent to build a career in this field\n4. Strong relationships on campus",
    "Internship Description/Internship Posting Link": "https://bit.ly/2wnWDx4",
    "Contact details for the opportunity(Email)": "rishavkumar@cashkaro.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 12:27:44",
    "Company Name": "Cybercad technologies",
    "Internship Domain": "Marketing, research",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "Cybercad.in",
    "Any expectations from the intern?":
      "Good with research and has some understanding of a feasibility study",
    "Internship Description/Internship Posting Link":
      "We are looking for pan india research on utility billing as well as logistics sector",
    "Contact details for the opportunity(Email)":
      "Amey@cybercadtechnologies.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/10/2020 13:46:48",
    "Company Name": "Euphotic Labs PVT LTD",
    "Internship Domain": "1. Marketing 2. Graphic & text Content creations 3.",
    "Duration of the internship (Months)": "2-6",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "Euphotic.io",
    "Any expectations from the intern?": "Self driven and passionate.",
    "Internship Description/Internship Posting Link":
      "https://angel.co/l/2rZSTf",
    "Contact details for the opportunity(Email)": "yatin@euphotic.io",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 05:30:11",
    "Company Name": "A+G Digital",
    "Internship Domain": "Digital Strategy",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://agdigital.us",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "contact@agdigital.us",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 09:20:50",
    "Company Name": "ParShiksha",
    "Internship Domain": "Software Development",
    "Duration of the internship (Months)": "2 Months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://parshiksa.org",
    "Any expectations from the intern?": "Experience with Javascript, Python.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "parshiksha@gmail.com",
    "Anything else you'd like to share?":
      "Vision and Mission: https://link.medium.com/eCVfcIhvA5",
  },
  {
    Timestamp: "04/11/2020 10:10:18",
    "Company Name": "Dhivik",
    "Internship Domain": "Sales and Marketing",
    "Duration of the internship (Months)": "6 months and above",
    "Are you open to on-board remote interns?": "No",
    "Website of the company": "www.gogreenbov.com",
    "Any expectations from the intern?":
      "Analytical mind-set, problem solving capabilities",
    "Internship Description/Internship Posting Link":
      "GoGreenBOV is an electric two wheeler company which is B2B focussed. There are 22 slots open in the field of marketing and sales. From lead gen to tracking to closure.",
    "Contact details for the opportunity(Email)": "Info@gogreenbov.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 20:27:56",
    "Company Name": "carpathy",
    "Internship Domain": "operations and sales",
    "Duration of the internship (Months)": "3 months till july of 2020.",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.carpathy.com",
    "Any expectations from the intern?": "Understanding new market.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "Rakeshreddy9362@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/11/2020 23:39:00",
    "Company Name": "Label nimisha singhal",
    "Internship Domain": "Graphic desigber",
    "Duration of the internship (Months)": "2 mnths",
    "Are you open to on-board remote interns?": "nimishasinghal@yahoo.com",
    "Website of the company": "Www.instagram.com/ labelnimishasinghal",
    "Any expectations from the intern?":
      "Should be well versed with the softwares. The desig. Skills and aesthetics should be good. Preferably a reputed college",
    "Internship Description/Internship Posting Link":
      "Looking for graphic design student to work on our catalogue and somsreworking on logo",
    "Contact details for the opportunity(Email)": "nimishasinghal@yahoo.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/12/2020 06:30:53",
    "Company Name": "Aanya Wellness",
    "Internship Domain": "Video Editor cum animator",
    "Duration of the internship (Months)": "2-3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.aanyawellness.com",
    "Any expectations from the intern?":
      "Should be able to use FCP or any other video editing tool and after effects",
    "Internship Description/Internship Posting Link":
      "The intern shall be aligned to edit basic videos from our shoots, and make basic abd appealing animations.",
    "Contact details for the opportunity(Email)": "pulkit@aanyawellness.com",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "04/12/2020 22:55:20",
    "Company Name": "Blackfish Technologies Private Limited",
    "Internship Domain": "Distributed systems - Blockchains",
    "Duration of the internship (Months)": "2-3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.marlin.pro/",
    "Any expectations from the intern?":
      "Generalists, solid understanding of CS fundamentals",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/document/d/1kEWiKRSyGqdpkhs4CDnHMNgPepZPPQWUzfFfMDkucPw",
    "Contact details for the opportunity(Email)": "roshan@blackfishtech.in",
    "Anything else you'd like to share?":
      "Competitive pay, great hands-on development experience",
  },
  {
    Timestamp: "04/12/2020 23:49:56",
    "Company Name": "Penser",
    "Internship Domain": "Product Design and Development",
    "Duration of the internship (Months)": "Two",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.penser.co.uk",
    "Any expectations from the intern?":
      "Product research, requirements development, use case definition",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "victoria@penser.co.uk",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/13/2020 13:18:51",
    "Company Name": "Alfred Technologies",
    "Internship Domain": "Mobile App Developer",
    "Duration of the internship (Months)": "2 Month",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "http://alfredtechnologies.in/",
    "Any expectations from the intern?":
      "1. Building and designing advanced Android applications for Android platform\n2. Working with cross-functional team collaboration to design, define, and ship new features\n3. Using and working with outside APIs and data sources\n4. Performing a unit test to ensure usability, robustness, edge cases, and general reliability\n5. Working on bug fixing and improving application performance\n6. Working on continuous evaluation, discovery, and implementation of new technologies to maximize the efficiency of development.",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/1aV3tAZ21uaOCUQsA84AgFkxzex-QYRPB2aeJSPwVKVI/edit",
    "Contact details for the opportunity(Email)": "selection.alfred@gmail.com",
    "Anything else you'd like to share?":
      "Alfred Technologies is a social technology company. Our vision is to make the world a better place. We do so by using human, intellectual and digital resources in order to influence social processes.",
  },
  {
    Timestamp: "04/13/2020 22:14:18",
    "Company Name": "AllinCall Research and Solutions",
    "Internship Domain": "Technology",
    "Duration of the internship (Months)": "6 Months. Starting immediately.",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.allincall.in/",
    "Any expectations from the intern?": "Strong set of programming skills",
    "Internship Description/Internship Posting Link":
      "https://hr.allincall.in/hr-manager/careers/",
    "Contact details for the opportunity(Email)": "careers@allincall.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 13:02:37",
    "Company Name": "My Medicine Box",
    "Internship Domain": "Not an internship",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "",
    "Any expectations from the intern?":
      "1. Website development \n2. App development \n3. Chatbot \n4. CRM software development ",
    "Internship Description/Internship Posting Link":
      "My Medicine Box is a 5-year-old start-up based out of Mumbai. We serve around 50,000 orders each year. We had a revenue of INR 4,50,00,000 for the year 2019-2020.   So we are looking for developers to join our core team on an equity basis. We are at the break-even stage so we can't pay salaries as of now. 2.5% sweat equity ( means something between INR 9L to INR 40L )  will be allotted to every developer we will take in the team. We will try to pay some salaries but can't promise as of now.",
    "Contact details for the opportunity(Email)": "ashutosh@medily.in",
    "Anything else you'd like to share?":
      "We are looking to have 5 people in our team to handle the technical work and maintaining that. Interested people, please fill this form : https://forms.gle/hejQ2A2zzre2twQW6",
  },
  {
    Timestamp: "04/15/2020 16:12:39",
    "Company Name": "Global market Insights Research Pvt. Ltd",
    "Internship Domain": "Content writing",
    "Duration of the internship (Months)": "3 to 6 months",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "https://www.gminsights.com/",
    "Any expectations from the intern?":
      "�\tAny Graduates / Post-Graduate candidates with Excellent communication skills.\n�\tPreferred ::  BA-English, Journalism, Mass communication or equivalent Qualification.\n�\tInternship duration- 3 to 6 months.\n�\tShould be interested in content writing.\n�\tWe can consider candidates pursuing content writing courses from the institutes in Pune.",
    "Internship Description/Internship Posting Link":
      "Develop strong content for company website, articles, blogs, with regular update, email newsletters, online marketing campaigns � Plan, develop, create, write and edit informative SEO content � Support social media and PR requirements to meet organizational goals � Responsible for overall development and enhancement of content as required for other emerging formats � Understand the company's SEO strategy and suggest relevant content to drive traffic to the website � Monitor team performance and report on metrics � Must be responsible for overall development and enhancement content as required for other emerging formats. � Check and improve current website content for proper keyword usage. � Develop content to support SEO strategies to drive traffic to the site and improve website ranking.",
    "Contact details for the opportunity(Email)": "puja.sakhare@gminsights.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 19:04:42",
    "Company Name": "Vivid Resourcing",
    "Internship Domain": "Machine Learning",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.vividresourcing.com",
    "Any expectations from the intern?":
      "Help our ML experts in our candidate ranking and matching system",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)":
      "Callum.Crockett@vividresourcing.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/15/2020 19:44:47",
    "Company Name": "Selby Jennings",
    "Internship Domain": "Machine Learning - Resumes",
    "Duration of the internship (Months)": "3-6",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.selbyjennings.com",
    "Any expectations from the intern?":
      "Create a candidate recommendation system to match job seekers and job openings",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)":
      "brandon.nyland@selbyjennings.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/16/2020 13:37:15",
    "Company Name": "Go GreenEOT ( Energy of Things ) Pvt Ltd.",
    "Internship Domain": "Marketing, Engineering, Sales",
    "Duration of the internship (Months)": ">6 Months",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "www.gogreenbov.com",
    "Any expectations from the intern?":
      "If your applying for marketing/ sales we would expect you to be extremely good with language, having gift of gab is an added advantage and one who can confuse when you cannot convince is a person ready to be hired. \nFor enginnering we are looking at engineers in the field of Mechanical and Electronics for working with an electric two wheeler company. As a company we are extremely forward thinking with around 16 patents in the battery, mobility and energy storage space.",
    "Internship Description/Internship Posting Link":
      "You would be working in a future ready industry of ELECTRIC MOBILITY. Job is in the field of marketing, sales, engineering. Please refer expectations from intern for oppurtunities.",
    "Contact details for the opportunity(Email)": "info@gogreenbov.com",
    "Anything else you'd like to share?":
      'Kindly add subject line " Job Search ref. by Tanuja" ',
  },
  {
    Timestamp: "04/16/2020 15:25:00",
    "Company Name": "Makerobos Innovation Labs",
    "Internship Domain": "Data Science",
    "Duration of the internship (Months)": "2 Months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.makerobos.com/",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "sparsh@makerobos.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 11:31:24",
    "Company Name": "Avtaar",
    "Internship Domain": "Edutech",
    "Duration of the internship (Months)": "2 months. 1st May - 30 June",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "Wip",
    "Any expectations from the intern?": "Passion for education",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/posts/tushar2bansal_tech-intern-education-activity-6655339177271488512-Dsdb",
    "Contact details for the opportunity(Email)": "tushar2bansal@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/17/2020 12:49:29",
    "Company Name": "Tap In",
    "Internship Domain": "Andriod or iOS Development",
    "Duration of the internship (Months)": "2, start date- immediate",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://tapin.news",
    "Any expectations from the intern?":
      "Must be sklilled in Android or iOS development",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/posts/abeer-choubey_ios-android-iosdevelopers-activity-6652880937522651137-aN7l",
    "Contact details for the opportunity(Email)": "tapindev@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/20/2020 14:43:48",
    "Company Name": "Dhyani Consulting Services",
    "Internship Domain": "Marketing, Operations, Content, Graphics",
    "Duration of the internship (Months)": "2 Months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "Under modification",
    "Any expectations from the intern?": "Common Sense, Proactive",
    "Internship Description/Internship Posting Link":
      "Market Research\nContent developement for various products\nSocial media platforms handling\nCommunication with potential clients\nMaintaining data\nReporting the analyzed data",
    "Contact details for the opportunity(Email)":
      "dhyaniconsultingservices@gmail.com",
    "Anything else you'd like to share?":
      "We have started this initiative specifically for students in this covid 19 difficulties.",
  },
  {
    Timestamp: "04/20/2020 17:30:42",
    "Company Name": "",
    "Internship Domain": "MBA Interns ll Gurgaon",
    "Duration of the internship (Months)":
      "Opening for Finance Interns  Internship - 2 Months",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "Immediate virtual internship for 2 month's starting mid April �  MBA finance students are required �  Applicant must have personal laptop/ desktop with internet connection �  Stipend will be paid for 2 months",
    "Contact details for the opportunity(Email)": "jaspreet.singh@acuitykp.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 11:09:40",
    "Company Name": "Deloitte, IBM,PWC",
    "Internship Domain": "Data science /software companies/communication",
    "Duration of the internship (Months)": "1 months",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "Deloitte,SAP",
    "Any expectations from the intern?": "I will give my best for the company",
    "Internship Description/Internship Posting Link": "NA",
    "Contact details for the opportunity(Email)": "siddhipandey223@gmail.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/21/2020 22:10:41",
    "Company Name": "Livygo technologies pvt Ltd",
    "Internship Domain": "Business development, Sales, and HR",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.livygo.com",
    "Any expectations from the intern?": "Looking for smart people.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "Career@livygo.com",
    "Anything else you'd like to share?": "None",
  },
  {
    Timestamp: "04/21/2020 22:21:03",
    "Company Name": "Salesforce",
    "Internship Domain": "ESMB Intern",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://salesforce.wd1.myworkdayjobs.com/en-US/External_Career_Site/job/India---Bangalore/ESMB-Intern_JR64330-1",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 22:25:54",
    "Company Name": "Atom",
    "Internship Domain": "Communication and Content Strategy, Intern",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/jobs/view/1822413098",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 22:28:44",
    "Company Name": "IIFL",
    "Internship Domain": "Gold Appraiser (Job)",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "http://careers.iifl.com/jobs/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 22:30:15",
    "Company Name": "IIFL",
    "Internship Domain": "Finance And Marketing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://internshala.com/internship/details/finance-and-marketing-work-from-home-job-internship-at-iifl-securities-limited1586429334",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 22:43:33",
    "Company Name": "BLive",
    "Internship Domain": "Financial modeling",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/posts/letsblivein_interns-internshipopportunity-internshipprogram-activity-6653919198336638976-jL44",
    "Contact details for the opportunity(Email)": "Info@blive.co",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 22:44:28",
    "Company Name": "Blive",
    "Internship Domain": "Digital marketing, customer acquisition",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/posts/letsblivein_interns-internshipopportunity-internshipprogram-activity-6653919198336638976-jL44",
    "Contact details for the opportunity(Email)": "Info@blive.co",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/21/2020 22:47:02",
    "Company Name": "WorkAmp",
    "Internship Domain": "Multiple",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "Kunal.gupta@workamp.co",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 18:59:58",
    "Company Name": "Park+",
    "Internship Domain": "BD",
    "Duration of the internship (Months)": "As soon as you get selected",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "parkplus.io",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)":
      "harshvardhan.mittal@myparkplus.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/22/2020 23:43:00",
    "Company Name": "ForeignAdmit",
    "Internship Domain": "Tech, NonTech",
    "Duration of the internship (Months)":
      "3 Months minimum (6 months prefered)",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://foreignadmits.com",
    "Any expectations from the intern?":
      "Prior Project or Internship Experience in Same Domain and Skills set is mandatory. We don't have training periods.",
    "Internship Description/Internship Posting Link":
      "https://foreignadmits2020.typeform.com/to/SUklat",
    "Contact details for the opportunity(Email)":
      "Careers@foreignadmits.com\n\n(Applications to be considered only via typeform)",
    "Anything else you'd like to share?":
      "We don't entertain any Casual Application at all. Apply only if your profile matches strongly with Target roles. We offer paid and performance based rewards",
  },
  {
    Timestamp: "04/24/2020 05:55:17",
    "Company Name": "Trendful",
    "Internship Domain": "Social Media Intern",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://trendful.com/pages/career",
    "Contact details for the opportunity(Email)":
      "career@trendful.com with resume and cover letter",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/24/2020 05:59:19",
    "Company Name": "Arcatron Mobility Private Limited",
    "Internship Domain":
      "Accounts & Finance, Graphic Design, Video Making and Editing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://arcatron.com/",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://arcatron.com/career-at-arcatron/",
    "Contact details for the opportunity(Email)":
      "ganesh@arcatron.com, arif@arcatron.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/24/2020 15:06:59",
    "Company Name": "The MSA Group",
    "Internship Domain": "Geology/Mining",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "http://msagroupservices.com/careers-portal/graduates",
    "Contact details for the opportunity(Email)":
      "zakiyyag@msagroupservices.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/25/2020 10:50:10",
    "Company Name": "Expertrons",
    "Internship Domain": "Sales",
    "Duration of the internship (Months)":
      "Duration 3 Months - Can start immediate",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://expertrons.com/",
    "Any expectations from the intern?":
      "1. Good communication\n2. Very Interactive\n3. Open to learning",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/e/1FAIpQLSdTWi1dcHVGklemP8MJaD3B3BoYGaggkxQ7sFaqQ0W98I0dYg/viewform",
    "Contact details for the opportunity(Email)": "hr@expertrons.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/25/2020 10:53:34",
    "Company Name": "Expertrons",
    "Internship Domain": "Business Development",
    "Duration of the internship (Months)":
      "Duration 3 months / can start immediate",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://expertrons.com/",
    "Any expectations from the intern?":
      "1. Good Interpersonal skills\n2. Decision Making skills\n3. Open to Learning",
    "Internship Description/Internship Posting Link":
      "Business Development Internship - http://bit.ly/bdjdcolexpertrons",
    "Contact details for the opportunity(Email)": "hr@expertrons.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/25/2020 21:51:19",
    "Company Name": "Google",
    "Internship Domain": "Journalism emergency relief fund",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://newsinitiative.withgoogle.com/journalism-emergency-relief-fund/",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "04/26/2020 03:01:33",
    "Company Name": "Danalitic India",
    "Internship Domain": "Digital Marketing",
    "Duration of the internship (Months)": "3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.danalitic.com",
    "Any expectations from the intern?": "Have some basic knowledge",
    "Internship Description/Internship Posting Link":
      "Good into SEO strategy and have good knowledge of SEO. And content creation",
    "Contact details for the opportunity(Email)": "agupta@danalitic.com",
    "Anything else you'd like to share?": "No",
  },
  {
    Timestamp: "04/28/2020 23:39:04",
    "Company Name": "CaterNinja",
    "Internship Domain": "",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "Our portfolio company CaterNinja (www.CaterNinja.com) is looking to hire a Rockstar to drive and own growth. Preferably from the food sector(food delivery/cloud kitchen/fresh food brands)",
    "Contact details for the opportunity(Email)":
      "please get in touch with team at admin@caterninja.com with the Subject Line - 'Application_Growth_CaterNinja'.",
    "Anything else you'd like to share?":
      "https://yourstory.com/2018/10/investment-banker-turned-entrepreneur-caterer-aggregator-caterninja/",
  },
  {
    Timestamp: "04/29/2020 15:55:57",
    "Company Name": "Integrated Tech9labs",
    "Internship Domain": "Business Analysis",
    "Duration of the internship (Months)": "6 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.tech9labs.com",
    "Any expectations from the intern?":
      "Understanding of business operations and analysis of data, resources, etc to recommend the appropriate solution. However, training will give for the same.",
    "Internship Description/Internship Posting Link": "NA",
    "Contact details for the opportunity(Email)": "mohit.thukral@tech9labs.com",
    "Anything else you'd like to share?":
      "Performance during internship may help you get a full time job with us after 6 months.",
  },
  {
    Timestamp: "04/29/2020 15:57:48",
    "Company Name": "Integrated Tech9labs Pvt Ltd",
    "Internship Domain": "Technology  / Software Development",
    "Duration of the internship (Months)": "6 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.tech9labs.com",
    "Any expectations from the intern?":
      "Software Development, App Development, etc. However, we will provide training as well.",
    "Internship Description/Internship Posting Link": "NA",
    "Contact details for the opportunity(Email)": "mohit.thukral@tech9labs.com",
    "Anything else you'd like to share?":
      "After 6 months training, full time opportunity can be given based on performance of the candidate.",
  },
  {
    Timestamp: "05/01/2020 21:10:56",
    "Company Name": "ParShiksha",
    "Internship Domain": "Software Engineering",
    "Duration of the internship (Months)": "2 months (May - June, 2020)",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://parshiksha.org/",
    "Any expectations from the intern?": "Web-Development/Mobile Development.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "parshiksha@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/02/2020 13:42:23",
    "Company Name": "Skyquest Technology Group",
    "Internship Domain":
      "Pshycology, Content writer, Market Research, Power BI Developer,",
    "Duration of the internship (Months)": "2 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company":
      "http://skyquestt.com/global-market-intelligence/career/",
    "Any expectations from the intern?":
      "Dedicated for full 2 months, ablity to take sense of responsibility l.",
    "Internship Description/Internship Posting Link": "Posted on Internshala",
    "Contact details for the opportunity(Email)": "Careers@skyquestt.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/04/2020 01:52:54",
    "Company Name": "MyWays",
    "Internship Domain": "Machine Learning Intern",
    "Duration of the internship (Months)": "2 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.myways.in",
    "Any expectations from the intern?":
      "YoWe are looking for ML Engineers for designing and developing machine learning and deep learning systems, implementing appropriate ML algorithms, running machine learning tests and experiments. Strong coding experience in Python. Understanding of machine learning framework like scikit-learn, keras, pytorch, etc. Good knowledge of probability, linear algebra, statistics , data structure and algorithms.",
    "Internship Description/Internship Posting Link":
      "https://dashboard.myways.in/about/internship/machine-learning-intern-b41c7",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "Deadline to apply- 5th May 2020",
  },
  {
    Timestamp: "05/05/2020 04:15:24",
    "Company Name": "AlgoPay",
    "Internship Domain": "UX",
    "Duration of the internship (Months)": "Flexible, starting May 2020",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.algopay.io",
    "Any expectations from the intern?":
      "Past experience with app design preferred, fintech work optional",
    "Internship Description/Internship Posting Link": "N/A",
    "Contact details for the opportunity(Email)": "bridget@algopay.io",
    "Anything else you'd like to share?":
      "AlgoPay is a Techstars-backed fintech startup. It launched its beta product following its time at Techstars LA this past fall and is building a 2.0 product to accommodate high user demand. We're an extremely agile, quickly-moving company & we're extremely excited to design an incredible 2.0 product for our users.",
  },
  {
    Timestamp: "05/06/2020 12:39:45",
    "Company Name": "Red Dot Foundation",
    "Internship Domain": "Android(Kotlin) and IOS(Swift) developers",
    "Duration of the internship (Months)": "3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.safecity.in",
    "Any expectations from the intern?":
      "More than or equal to 1 year experience in developing & debugging Android and IOS apps",
    "Internship Description/Internship Posting Link":
      "Safecity is providing an opportunity for developers from across the nation to be a part of noble cause - to make our Cities safer. A certificate and LOR will be issued on basis of performance.",
    "Contact details for the opportunity(Email)": "india.safecity@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/07/2020 21:32:41",
    "Company Name": "Imaginate Software Labs Pvt Ltd",
    "Internship Domain": "Development",
    "Duration of the internship (Months)": "3-6 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.imaginate.in",
    "Any expectations from the intern?":
      "Working on Unity 3D, C#, computer vision 2. Developing multi-player games",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "prasanna@imaginate.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/07/2020 21:35:27",
    "Company Name": "Imaginate Software Labs Pvt Ltd",
    "Internship Domain": "UI/UX Design",
    "Duration of the internship (Months)": "3-6 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.imaginate.in",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/07/2020 23:29:59",
    "Company Name": "Josh Talks",
    "Internship Domain": "Content creation",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/e/1FAIpQLSfvABObEtBT89HIESdqzrtpG6N01gfrhG3bN2Rh0DlD21uNPQ/viewform",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "Hindi, English is a must",
  },
  {
    Timestamp: "05/08/2020 17:25:39",
    "Company Name": "Commutec",
    "Internship Domain": "Digital Sales",
    "Duration of the internship (Months)": "3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.comutec.in",
    "Any expectations from the intern?": "Communication and digital marketing",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "randeep@commutec.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/10/2020 14:47:22",
    "Company Name": "Spruce Shave Club",
    "Internship Domain":
      "Content Writing/Content Marketing, Social Media Marketing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.spruceshaveclub.com",
    "Any expectations from the intern?":
      "Active on Social media with a good understand of all different channels. Good written and spoken English. Preferred interest in fashion/grooming/lifestyle.",
    "Internship Description/Internship Posting Link":
      "Content - Working with us to solidify our Image as Grooming & Lifestyle partners for men rather than just a company that sells products. - We want to work on creating informed and helpful content across multiple mediums like our own blog, quora, medium, yahoo answers in terms of written content. - Would also be working with our team to streamline our general communication on those lines.  Social Media - Ideate and help us execute a streamlined calendar for our social platforms in line with the kind of content we are creating -  Ideate campaigns we can run around that kind of content. - Research and suggest long form video content ideas to help us build out our youtube channel as grooming experts. - Build a strategy for Tik Tok marketing. What kind of content can we create  and how we can do it - Find and connect with low budget/barter influencers who can help us create better content for our social media (ideally video content).",
    "Contact details for the opportunity(Email)": "aditya@spruceshaveclub.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/13/2020 19:49:24",
    "Company Name": "Readerspace.in",
    "Internship Domain":
      "Newspaper Analyzer, Current Affairs content writer, Finance Analyzer, Stock Market Analyzer, Graphics designer, Social Media Handler.",
    "Duration of the internship (Months)": "May - November",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.readerspace.in",
    "Any expectations from the intern?":
      "Have a good set of skills, even if not. Should be of learning nature. Internship is un-paid in nature.",
    "Internship Description/Internship Posting Link":
      "https://forms.gle/efm2MitE36Sjw2Dy5",
    "Contact details for the opportunity(Email)": "info.readerspace@gmail.com",
    "Anything else you'd like to share?":
      "Un-Paid Internship. Just an learning experience for people.",
  },
  {
    Timestamp: "05/14/2020 03:11:02",
    "Company Name": "Wheelseye Technology India Private Limited",
    "Internship Domain": "Graphic Designer, Illustrator, Visual Artist",
    "Duration of the internship (Months)": "Full Time",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "www.wheelseye.com",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/posts/sonesh-jain-31065b48_designer-illustrators-digitalartists-activity-6666354680177786880-lQvM",
    "Contact details for the opportunity(Email)": "sonesh.jain@wheelseye.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/14/2020 12:54:16",
    "Company Name": "TSAW",
    "Internship Domain": "Website Development",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "www.tsaw.tech",
    "Any expectations from the intern?": "PHP development, file handling",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "hr@tsaw.tech",
    "Anything else you'd like to share?":
      "You can explore more about us at www.tsaw.tech\nCompany profile can be explored at www.angel.co/company/tsaw\n\nInterested candidates are requested to contact us at hr@tsaw.tech ",
  },
  {
    Timestamp: "05/14/2020 12:56:33",
    "Company Name": "TSAW",
    "Internship Domain": "Graphic Designing & Video Editing",
    "Duration of the internship (Months)": "1-2 months",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "www.tsaw.tech",
    "Any expectations from the intern?":
      "We will be preferring individuals with good design visualisation, even if having bit weak command on software usage.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "hr@tsaw.tech",
    "Anything else you'd like to share?":
      "You can explore more about us at www.tsaw.tech\nCompany profile can be explored at www.angel.co/company/tsaw\n\nInterested candidates are requested to contact us at hr@tsaw.tech ",
  },
  {
    Timestamp: "05/14/2020 16:24:44",
    "Company Name": "Codesnag",
    "Internship Domain": "UI/Frontend",
    "Duration of the internship (Months)": "1",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.codesnag.com",
    "Any expectations from the intern?":
      "Good designing skills, fontend frameworks",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "hr@hackdevtechnology.com",
    "Anything else you'd like to share?": "no",
  },
  {
    Timestamp: "05/15/2020 13:39:48",
    "Company Name": "Rachnashala Productions",
    "Internship Domain": "Social Media",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.rachnashala.com",
    "Any expectations from the intern?": "Social Media",
    "Internship Description/Internship Posting Link":
      "Assist with the design and execution of social media campaigns Create weekly and monthly editorial calendars to promote company brands on various social media websites Create and distribute content such as blogs, infographics, videos and press releases on social media and traditional news outlets Track social media engagement to identify high-performing ideas and campaigns for scalability Support marketing team at live and online events",
    "Contact details for the opportunity(Email)": "kripie@rachnashala.com",
    "Anything else you'd like to share?":
      "Ideating, creating and posting content to different social media platforms\nPlanning and adhering to content calendars to schedule posts on different social media platforms\nOptimizing content, tracking user traffic and assessing user response to different content posted\nHelp plan social media campaigns to reach a wider audience, increase brand awareness and drive sales\nPhotography, graphic design and video content creation",
  },
  {
    Timestamp: "05/15/2020 23:00:11",
    "Company Name": "Open Brain Society",
    "Internship Domain": "Education",
    "Duration of the internship (Months)":
      "2 Months; starting from 20 May, 2020",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.openbrainsociety.com",
    "Any expectations from the intern?": "Content Creation",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/e/1FAIpQLSefc24k5_4lhs8gHskEiJSslRwUK1BK8LCYdh0NvXIWo37rCQ/viewform",
    "Contact details for the opportunity(Email)":
      "Support@openbrainsociety.com",
    "Anything else you'd like to share?":
      "Open Brain Society is an educational initiative which is targeting younger generation of the country to give them logical thinking and Decision Making skills so that they become self sufficient. \n\nWould you like to know more - Just shoot a question at my Whatsapp number: 7042913845",
  },
  {
    Timestamp: "05/15/2020 23:18:22",
    "Company Name": "Open Brain Society",
    "Internship Domain": "Education",
    "Duration of the internship (Months)": "2 Months; 25 May, 2020",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.openbrainsociety.com",
    "Any expectations from the intern?":
      "Linkedin Intern for getting leads from linkedin, content creation, marketing",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/135rC9GJAUrwmQcl9PjdXTFgfoCK_NFDKzz0O0km8u4w/edit",
    "Contact details for the opportunity(Email)":
      "Support@openbrainsociety.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/16/2020 09:32:27",
    "Company Name": "Nearby Grocer",
    "Internship Domain": "Web Development",
    "Duration of the internship (Months)": "1 month",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.nearbygrocer.com",
    "Any expectations from the intern?":
      "We are looking for a Backend Developer (Strong profile in PHP, HTML, and Codeigniter, etc)",
    "Internship Description/Internship Posting Link":
      "Apply here:https://bit.ly/3dGoQz1  Thanks.",
    "Contact details for the opportunity(Email)": "javed@nearbygrocer.com",
    "Anything else you'd like to share?": "NA",
  },
  {
    Timestamp: "05/17/2020 16:30:38",
    "Company Name": "Quantel",
    "Internship Domain": "All",
    "Duration of the internship (Months)": "Virtual self paced internships",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "upgrade your skills",
    "Internship Description/Internship Posting Link":
      "https://linktr.ee/quantel",
    "Contact details for the opportunity(Email)": "hello@quantel.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/19/2020 11:33:06",
    "Company Name": "Commutec",
    "Internship Domain":
      "Digital marketing, Andriod, Supply chain - Operations",
    "Duration of the internship (Months)": "3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.commutec.in",
    "Any expectations from the intern?": "Experience",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "randeep@commutec.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/19/2020 18:18:38",
    "Company Name": "Vahan",
    "Internship Domain": "Data Science/Machine Learning",
    "Duration of the internship (Months)": "May-July, 2020",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://vahan.ai/",
    "Any expectations from the intern?":
      "Product mindset - understand the product and figure out what data is needed to solve the problem at hand\nHacker mindset - understand the problem statement and find a way to get the job done\nCoding and web scraping: Ability to write scripts to scrape data at scale. \nAPI integrations: ability to understand API specs and write the code to work and use to APIs to pull data\nSQL: ability to write neat, clean and optimized SQL queries\nAbility to write code to clean vast volumes of data\nPrepare datasets for ML experimentation",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/document/d/1vow3FiiFhMSyPl7FQo_lwM3UiZpMYZxdPoeCMsHOPNU/edit",
    "Contact details for the opportunity(Email)": "info@vahan.co",
    "Anything else you'd like to share?":
      "LinkedIn- https://www.linkedin.com/feed/update/urn:li:activity:6666718053042151425/",
  },
  {
    Timestamp: "05/19/2020 21:02:29",
    "Company Name": "Sabintern Solutions Pvt Ltd",
    "Internship Domain": "Social Media Marketing",
    "Duration of the internship (Months)": "2 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "Sabintern.com",
    "Any expectations from the intern?":
      "Basic knowledge of Social Media Marketing",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "rrsabintern@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/19/2020 23:30:02",
    "Company Name": "Chhattisgarh Food Products",
    "Internship Domain":
      "communications, content creation and social media management",
    "Duration of the internship (Months)": "1.5 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Looking for a communication student/professional who is active on social media platforms and well versed with Instagram, Facebook and Twitter.  Desirable Qualifications �Media/Communication Student or Professional  �Proficient with English Language �Adobe suite proficiency is an added advantage �Active on social media platforms like Instagram, Facebook, Twitter  �Willing to work for 6-7 hours daily Deliverables �To make a social media strategy for promotion of our products and work.  �To write posts about our products and work and make it viral across social media platforms. �To increase followers of our page.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "cfp.honeybeecare@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/19/2020 23:45:00",
    "Company Name": "Chhattisgarh Food Products",
    "Internship Domain": "Social Media Marketing",
    "Duration of the internship (Months)": "45",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "�Media/Communication Student or Professional \n�Proficient with English Language\n�Adobe suite proficiency is an added advantage\n�Active on social media platforms like Instagram, Facebook, Twitter \n�Willing to work for 6-7 hours daily",
    "Internship Description/Internship Posting Link":
      "�To make a social media strategy for promotion of our products and work.  �To write posts about our products and work and make it viral across social media platforms. �To increase followers of our page.",
    "Contact details for the opportunity(Email)": "cfp.honeybeecare@gmail.com",
    "Anything else you'd like to share?": "Facebook",
  },
  {
    Timestamp: "05/19/2020 23:47:18",
    "Company Name": "Freedom Gazette",
    "Internship Domain": "Content Writing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "http://freedomgazette.in/",
    "Any expectations from the intern?":
      "passionate writers, willing to contribute to our agenda of propagating the inclusive and unifying values of India's freedom movement",
    "Internship Description/Internship Posting Link":
      "writing about policy issues, the development sector, economy, education and international affairs",
    "Contact details for the opportunity(Email)": "editor@freedomgazette.in",
    "Anything else you'd like to share?": "Facebook",
  },
  {
    Timestamp: "05/20/2020 17:52:10",
    "Company Name": "Waveland renewable energy Private Limited",
    "Internship Domain": "Digital Marketing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "http://www.cellulose.co.in/",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6666896137255043072/",
  },
  {
    Timestamp: "05/20/2020 17:53:48",
    "Company Name": "Waveland Renewable Energy Private Limited",
    "Internship Domain": "Finance - Equity Research",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "http://www.cellulose.co.in/contact.html",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6666896137255043072/",
  },
  {
    Timestamp: "05/21/2020 16:01:47",
    "Company Name": "Waveland Renewable Energy Private Limited",
    "Internship Domain":
      "Content writing (5 interns), HR (2 interns), Web development (5 interns), Business development intern ( 4 interns), Marketing intern ( 2 interns), Finance (4 interns)",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "http://www.cellulose.co.in/contact.html",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6666896137255043072/",
  },
  {
    Timestamp: "05/21/2020 16:08:30",
    "Company Name": "Airtel Xlabs",
    "Internship Domain": "Data Scientist",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.airtel.in/careers/airtelxlabs/",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6667004024665067520/",
  },
  {
    Timestamp: "05/21/2020 16:19:23",
    "Company Name": "Gurugram Police",
    "Internship Domain": "Cyber Security",
    "Duration of the internship (Months)": "1-1.5",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6666729280417988608/",
  },
  {
    Timestamp: "05/21/2020 16:29:39",
    "Company Name": "",
    "Internship Domain":
      "Digital Marketing (8 interns), Finance - Equity Research (6 interns), Content writing (5 interns), HR (2 interns), Web development (5 interns), Business development intern ( 4 interns), Marketing intern ( 2 interns)",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://gaotek.com/",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6666649145123721216/",
  },
  {
    Timestamp: "05/21/2020 16:37:09",
    "Company Name": "Eli Lilly Services Pvt. Ltd.",
    "Internship Domain":
      "Global Scientific Communications Publications writing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.lilly.com/",
    "Any expectations from the intern?":
      "scientific writing, good learning agility, excellent oral and written communication skills",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)":
      "Lilly_Recruiting_Compliance@lists.lilly.com",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6666667226378186752/",
  },
  {
    Timestamp: "05/21/2020 16:41:37",
    "Company Name": "ResearchUSA",
    "Internship Domain": "Data Research Analyst",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.researchusainc.com/",
    "Any expectations from the intern?":
      "above a 3.0 GPA and willing to work 30+ hours weekly remotely with no set times",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6666725910898728962/",
  },
  {
    Timestamp: "05/21/2020 17:47:54",
    "Company Name": "",
    "Internship Domain": "Business analyst",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "shashank.sahu@IDfy.com",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6666705250231156737/",
  },
  {
    Timestamp: "05/21/2020 17:49:36",
    "Company Name": "",
    "Internship Domain": "Social Media marketing",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn- https://www.linkedin.com/feed/update/urn:li:activity:6667337500605980672/",
  },
  {
    Timestamp: "05/21/2020 17:59:37",
    "Company Name": "InCampus Ltd",
    "Internship Domain":
      "Marketing, Business Development, Content Creation/Marketing, Video Editor / Animator, UI/UX Designer, Graphic Designer",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6666774237723934720/",
  },
  {
    Timestamp: "05/21/2020 18:05:26",
    "Company Name":
      "Centre for Product Design and Manufacturing (CPDM), IISc Bangalore",
    "Internship Domain": "Project Staff",
    "Duration of the internship (Months)": "6-12",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "bgm@iisc.ac.in",
    "Anything else you'd like to share?":
      "https://www.linkedin.com/feed/update/urn:li:activity:6667520750938927104/",
  },
  {
    Timestamp: "05/21/2020 18:26:47",
    "Company Name": "Lakshya",
    "Internship Domain": "web design",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://lakshya.net.in/",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "dasguptaannesha@gmail.com",
    "Anything else you'd like to share?": "Facebook",
  },
  {
    Timestamp: "05/21/2020 18:29:38",
    "Company Name": "",
    "Internship Domain": "backend and frontend development",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "rakesh@yaanam.in",
    "Anything else you'd like to share?": "Reference- Tanuja Nainwal",
  },
  {
    Timestamp: "05/24/2020 01:21:07",
    "Company Name": "Hackergram",
    "Internship Domain": "Executive assistant",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://hackergram.org",
    "Any expectations from the intern?":
      "Strong Google Drive skills\nStrong Communication Skills\nStrong online research skills \nStrong social media skills\nAbility to maintain a calendar/schedule and a to-do list",
    "Internship Description/Internship Posting Link":
      "https://docs.google.com/forms/d/e/1FAIpQLScNlEm5JZ8oVpBD56ie-0IZNqC7InOVmjh7Epi0TbRqbNjxKA/viewform",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?": "Facebook",
  },
  {
    Timestamp: "05/25/2020 04:16:41",
    "Company Name": "My Nomadic Lifestyle",
    "Internship Domain": "SEO",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "agarwalamish05@gmail.com",
    "Website of the company": "www.mynomadiclifestyle.com",
    "Any expectations from the intern?": "SEO, Backlink building",
    "Internship Description/Internship Posting Link":
      "www.mynomadiclifestyle.com/join-our-team",
    "Contact details for the opportunity(Email)": "agarwalamish05@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/25/2020 04:18:05",
    "Company Name": "My Nomadic Lifestyle",
    "Internship Domain": "Travel Blogging",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "agarwalamish05@gmail.com",
    "Website of the company": "www.mynomadiclifestyle.com",
    "Any expectations from the intern?": "Good English",
    "Internship Description/Internship Posting Link":
      "www.mynomadiclifestyle.com/join-our-team",
    "Contact details for the opportunity(Email)": "agarwalamish05@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/25/2020 09:05:13",
    "Company Name": "Coco cars",
    "Internship Domain": "Programming",
    "Duration of the internship (Months)": "2-3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://cococars.in",
    "Any expectations from the intern?": "React Native for mobile application",
    "Internship Description/Internship Posting Link":
      "React native for mobile application development",
    "Contact details for the opportunity(Email)": "Cococars2@gmail.com",
    "Anything else you'd like to share?":
      "Those who have experience in React native should apply only.",
  },
  {
    Timestamp: "05/25/2020 11:36:23",
    "Company Name": "Armee Born 2 inspire",
    "Internship Domain": "Marketing & Sales",
    "Duration of the internship (Months)": "1",
    "Are you open to on-board remote interns?": "goarmee@gmail.com",
    "Website of the company": "www.goarmee.in",
    "Any expectations from the intern?":
      "Passionate, good communicator and good cultural values.",
    "Internship Description/Internship Posting Link":
      "Brand research, target marketing ,developing ad campaigns.",
    "Contact details for the opportunity(Email)": "goarmee@gmail.com",
    "Anything else you'd like to share?": "Message at +918910232655",
  },
  {
    Timestamp: "05/25/2020 17:22:32",
    "Company Name": "LoveMint",
    "Internship Domain": "Graphic Design",
    "Duration of the internship (Months)": "3 Months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.mylovemint.com",
    "Any expectations from the intern?":
      "Should be good at Graphic Designing and Video Editing!",
    "Internship Description/Internship Posting Link":
      "*Hello Graphic Designers!*  LoveMint (www.mylovemint.com) is looking to hire an intern for the role of Graphic Designer & Social Media Manager for a duration of 3 Months.  *Roles & Responsibility* - Posting Daily on all the Social Media Channels of LoveMint. - Creating High Quality Graphics related to Dating Industry. - Respond to Queries and Comments on the Social Media Channels. - Maintain the Hygiene of the Social Media Channels. - Brainstorm with the Founders and Come-Up with New Ideas to Promote The App.  *About the App* LoveMint is a dating app which is currently in its launching phase and is planning to go live in the european region from August.  *What will you get?* - Letter of Recommendation - Internship Certificate - Stipend of ?3000 (LumpSum) - Opportunity to work Full Time with the Organization   *Contact* To Apply, WhatsApp on +91-8377880834 Contact Person - Abhijeet Saxena",
    "Contact details for the opportunity(Email)": "abhijeet@mylovemint.com",
    "Anything else you'd like to share?": "No!",
  },
  {
    Timestamp: "05/26/2020 10:46:31",
    "Company Name": "MakeShift",
    "Internship Domain": "Education & Innovation",
    "Duration of the internship (Months)": "3 - Starts immediately",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "http://nexteduthon.in/  www.makeshiftedc.com",
    "Any expectations from the intern?":
      "Writing, Recording, handling online events, report writing",
    "Internship Description/Internship Posting Link":
      "https://m.facebook.com/story.php?story_fbid=10157478069249157&id=518409156",
    "Contact details for the opportunity(Email)": "makeshiftedc@gmail.com",
    "Anything else you'd like to share?":
      "It's an unpaid internship which will help you to gain a lot of practical experience. Candidates who are okay with the condition should apply.",
  },
  {
    Timestamp: "05/26/2020 14:41:33",
    "Company Name": "School of Future",
    "Internship Domain": "Product",
    "Duration of the internship (Months)": "ASAP, Min 2 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://lnkd.in/fYbwgvq",
    "Any expectations from the intern?":
      "#Paid #Internship #Developer\nAt School of Future (https://lnkd.in/fYbwgvq), we are changing how teenagers across the world, learn skills relevant to their future.\nWe are looking for an intern who can work with us for at least 1 month in the following role:\n- Product Developer: Our platform is built using Bubble (a visual programming platform for non-developers)as a web-app. There are several projects that we are trying to solve, the most urgent one being: We�d like users to receive a push notification when they are not on the platform, so that they can go back to it. You would be working with the founding team to figure out how to execute this and other projects that would directly influence the user experience.\nApplications open till 26 May. Offer in hand by 29 May. Please fill in this form (https://lnkd.in/gBjYUC3).\np.s. While I will look at the comments and messages, the fastest way in is to apply using the google form.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "https://lnkd.in/gBjYUC3",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/28/2020 15:08:46",
    "Company Name": "The Bombay Train Charter Company",
    "Internship Domain":
      "Marketing, Technical , Research, Strategy, Product Management , HR & Leadership , Business Development",
    "Duration of the internship (Months)": "6 - 18 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company":
      "https://bombay-charter.herokuapp.com/new_site.html#parallax_services",
    "Any expectations from the intern?":
      "Please fill the form,https://forms.gle/2CpzDmpRVha4JNSz9",
    "Internship Description/Internship Posting Link":
      "https://forms.gle/2CpzDmpRVha4JNSz9",
    "Contact details for the opportunity(Email)":
      "bombaytraincharter@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "05/28/2020 17:45:40",
    "Company Name": "",
    "Internship Domain":
      "Testing, Angularjs, Django, Data Science, and Magento",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "Chennai",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Only third or final years students can apply.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "ashwin@ave-promagne.com",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6671003167645417472/",
  },
  {
    Timestamp: "05/28/2020 17:53:30",
    "Company Name": "Closer - College Network",
    "Internship Domain": "Django development",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Experienced in Django and are proficient in coding at production level.",
    "Internship Description/Internship Posting Link":
      "The technical internship is paid. 5k -10k Rs. per month or more depending on the work done by intern. If the candidate is exceptional in the work it can lead to hiring too.",
    "Contact details for the opportunity(Email)": "admin@closerdating.in",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6671419449398169600/",
  },
  {
    Timestamp: "05/30/2020 07:11:11",
    "Company Name": "India Cowin Action Network Uttar Pradesh",
    "Internship Domain": "Social Media Management",
    "Duration of the internship (Months)": "2 months",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "Cowinactionnetwork.in",
    "Any expectations from the intern?": "Smart Worker",
    "Internship Description/Internship Posting Link":
      "It ll be an interactive tenure of 2 months, where we will guide you and you will work in collaboration.",
    "Contact details for the opportunity(Email)":
      "9899299966\nrohan.mahajan1216@gmail.com",
    "Anything else you'd like to share?":
      "I ll help the interns with future placements reccomdations",
  },
  {
    Timestamp: "05/30/2020 08:51:09",
    "Company Name": "India Cowin Action Network Uttar Pradesh",
    "Internship Domain": "Client Servicing and Coordination",
    "Duration of the internship (Months)": "2 months",
    "Are you open to on-board remote interns?": "Maybe",
    "Website of the company": "cowinactionnetwork.in",
    "Any expectations from the intern?": "Smart Worker",
    "Internship Description/Internship Posting Link":
      "We need to connect with MP, MLAs , Pradhans and Sarpanchs for the ongroud problems of the NGOs and the self help groups.",
    "Contact details for the opportunity(Email)": "rohan.mahajan1216@gmail.com",
    "Anything else you'd like to share?":
      "We will give them counselling and help them with the job they are best suited for.",
  },
  {
    Timestamp: "05/30/2020 20:51:09",
    "Company Name": "Sleeping8",
    "Internship Domain": "Technical (For React Native App Developers)",
    "Duration of the internship (Months)": "3 Months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.sleeping8.com",
    "Any expectations from the intern?":
      "*Essential Skills/ Qualifications*\n�Minimum 6 months experience in React Native application development.\n�Proven experience in React Native components in native android.\n�Knowledge of React Native, Redux, ReactJS, API, Javascript.\n�Familiarity with the android SDK\n�Experience in working with integration of Web Services, REST & JSON APIs.\n�Flexible, Proactive & Self-motivated.\n�Troubleshooting and Problem solving attitude.\n�Should be comfortable with a disruptive remote, team-first work culture .",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "pratyush@sleeping8.com",
    "Anything else you'd like to share?":
      "\n�Shortlisted candidates will be going through *2 rounds of technical interview*\n\n>Selected Candidate(s) need to join immediately.\n\n>Stipend & Certificate included.",
  },
  {
    Timestamp: "06/01/2020 12:00:53",
    "Company Name": "CreatoMojo",
    "Internship Domain": "Illustrator / Graphic Design",
    "Duration of the internship (Months)": "1",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.creatomojo.com",
    "Any expectations from the intern?":
      "You will be involved in the development of an out of the box �Game�. We expect the candidate to be skilled in these softwares/fields:\n?? Character Illustrations ( Adobe Illustrator )\n? Graphics ( like Adobe Photoshop )\n? UI/UX ( not that kinda priority for us, but it�s a plus )",
    "Internship Description/Internship Posting Link":
      "We�re looking for a super cool Design Intern who can handle quite a lot of Illustrations and UI/UX responsibilities at CreatoMojo and some of its sub projects. You�ll be working closely with IIT Kgp grads and we will always start with a small briefing as well the guidance that you need.",
    "Contact details for the opportunity(Email)": "soumodip@creatomojo.com",
    "Anything else you'd like to share?":
      "College no bar, though Design school students are preferred.\nOhh! I forgot to say, It�s a paid internship.",
  },
  {
    Timestamp: "06/01/2020 12:03:56",
    "Company Name": "CreatoMojo",
    "Internship Domain": "Marketing & Sales",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.creatomojo.com",
    "Any expectations from the intern?":
      "We expect the candidate to be skilled in these fields:\n\nCan solve problem quickly\nThink creatively about sales ( ? We will teach you a little )\nGood in digital content writing\nKnows editing presentations, spreadsheets, docs etc",
    "Internship Description/Internship Posting Link":
      "We�re looking for super cool Sales Intern for a challenging role of customer acquisition at CreatoMojo and its sub projects. You�ll be working closely with the IIT Kgp grads and you will learn about all the sales aspect of a SaaS product.",
    "Contact details for the opportunity(Email)": "soumodip@creatomojo.com",
    "Anything else you'd like to share?":
      "CreatoMojo was created with a simple idea in mind - that it should be super easy for Journalists and Bloggers to create videos out of their articles. Using our SaaS platform, users can also create Conversational Stories which highlights problem-solution scenario and Trending Posters with which they can reach a wider audience.\n\nCreatoMojo was also part of The Farm Accelerator 2019 in Atlanta, with Comcast as one its investor. Prior to that, we were incubated at NASSCOM 10000 StartUp Bangalore and for a short duration at IIM Bangalore LaunchPad.",
  },
  {
    Timestamp: "06/01/2020 20:09:50",
    "Company Name": "STEM & Space",
    "Internship Domain": "Digital /social media",
    "Duration of the internship (Months)": "Minimum 3 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.stemandspace.com",
    "Any expectations from the intern?":
      "Impeccable communication skills, understanding of Facebook /Instagram, social media channel management",
    "Internship Description/Internship Posting Link":
      "You will be required to manage the social media channels of ours. You should be managing communication on the social. Media channels.",
    "Contact details for the opportunity(Email)": "Gautam@stemandspace.com",
    "Anything else you'd like to share?":
      "Pls see Facebook or Instagram channels - STEM & Space",
  },
  {
    Timestamp: "06/01/2020 22:23:45",
    "Company Name": "ForeignAdmits",
    "Internship Domain": "Sales,",
    "Duration of the internship (Months)": "June (Immediately) -  Min 2 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://foreignadmits.com/",
    "Any expectations from the intern?":
      "Sales Experience or Interest to do Sales & Business Development.",
    "Internship Description/Internship Posting Link":
      "https://foreignadmits.com/careers",
    "Contact details for the opportunity(Email)": "careers@foreignadmits.com",
    "Anything else you'd like to share?":
      "Full Time- Paid + Commission; Part Time - Only Commission",
  },
  {
    Timestamp: "06/02/2020 18:24:39",
    "Company Name": "ForeignAdmits",
    "Internship Domain": "Sales,",
    "Duration of the internship (Months)": "June (Immediately) -  Min 2 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://foreignadmits.com/",
    "Any expectations from the intern?":
      "Sales Experience or Interest to do Sales & Business Development.",
    "Internship Description/Internship Posting Link":
      "https://foreignadmits.com/careers",
    "Contact details for the opportunity(Email)": "careers@foreignadmits.com",
    "Anything else you'd like to share?":
      "Full Time- Paid + Commission; Part Time - Only Commission",
  },
  {
    Timestamp: "06/03/2020 10:42:55",
    "Company Name": "ForeignAdmits",
    "Internship Domain": "Sales & Business Development",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://foreignadmits.com/",
    "Any expectations from the intern?":
      "Having Passion towards Sales, Quick learner, Good Negotiator, Organized at Work.",
    "Internship Description/Internship Posting Link":
      "https://foreignadmits.com/careers",
    "Contact details for the opportunity(Email)": "nikhil@foreignadmits.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/03/2020 12:04:31",
    "Company Name": "Safemutualfunds",
    "Internship Domain": "Content Writing",
    "Duration of the internship (Months)": "2",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://safemutualfund.in/",
    "Any expectations from the intern?": "Research and Content Writing",
    "Internship Description/Internship Posting Link":
      "Do research and write articles related to mutual funds as per the topics given",
    "Contact details for the opportunity(Email)": "shubham12102163@gmail.com",
    "Anything else you'd like to share?": "Experience is the key to success",
  },
  {
    Timestamp: "06/03/2020 21:11:02",
    "Company Name": "Ncome Technologies Solutions",
    "Internship Domain": "Fintech",
    "Duration of the internship (Months)": "1-2 months",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.protectpay.in/",
    "Any expectations from the intern?":
      "UI/UX Design experience, working on wireframes",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "zyan@protectpay.in",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/06/2020 15:37:17",
    "Company Name": "Keeto",
    "Internship Domain": "Financial Services",
    "Duration of the internship (Months)": "1 month",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "NA",
    "Any expectations from the intern?":
      "Android App developers, Digital marketing, Business Development and Product Management",
    "Internship Description/Internship Posting Link":
      "https://www.linkedin.com/posts/akashkansal_index-of-activity-6674930230618013696-rLUa",
    "Contact details for the opportunity(Email)": "careers@keetoapp.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/08/2020 11:14:09",
    "Company Name": "Vumonic Datalabs",
    "Internship Domain": "UX Writing & Product Management",
    "Duration of the internship (Months)": "2 (can be extended)",
    "Are you open to on-board remote interns?":
      "1 Month Remote and 1 month in-office",
    "Website of the company": "vumonic.com",
    "Any expectations from the intern?":
      "Excellent in verbal and written communication. Basic idea about UX and Product.",
    "Internship Description/Internship Posting Link":
      "https://internshala.com//internship/detail/ux-writing-product-management-internship-in-banglaore-at-vumonic1590991955",
    "Contact details for the opportunity(Email)": "yathish@vumonic.com",
    "Anything else you'd like to share?":
      "This is a paid internship. We're specifically looking for someone with a strong content writing background (someone who has written SEO related content)",
  },
  {
    Timestamp: "06/09/2020 15:52:06",
    "Company Name": "Squad",
    "Internship Domain": "Research and Marketing",
    "Duration of the internship (Months)": "3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "https://www.squadvoice.co/?no-redirect",
    "Any expectations from the intern?":
      "- Excellent research skills (Knows how to get answers from the internet)\n- Basic knowledge of excel/ google sheets OR willing to learn and implement quickly\n- Decent communication skill (Can form summaries of research and communicate effectively with the team)",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "work@squadvoice.co",
    "Anything else you'd like to share?":
      "https://www.linkedin.com/pulse/our-hiring-framework-why-work-squadrun-apurv-agrawal",
  },
  {
    Timestamp: "06/09/2020 16:54:30",
    "Company Name": "Aarkaya Solar solution Pvt Ltd",
    "Internship Domain": "IOT",
    "Duration of the internship (Months)": "6-8",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "www.aarkaya.com",
    "Any expectations from the intern?":
      "Freshers with skills and hands onn experience on projects.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "technocrat726246@gmail.com",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "06/11/2020 18:45:00",
    "Company Name": "ORAI Robotics",
    "Internship Domain": "????? ??? ?????????",
    "Duration of the internship (Months)": "3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "all the tech savvy sales students who are looking forward to Make It Big in the world of Virtual Reality are welcome",
    "Internship Description/Internship Posting Link":
      "chance to land into a ???? ???? ??? ??????????? with us",
    "Contact details for the opportunity(Email)": "HR@orai-robotics.com",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6671649379918733312/",
  },
  {
    Timestamp: "06/11/2020 18:53:30",
    "Company Name": "The Bombay Train Charter Company",
    "Internship Domain":
      "Marketing,Technical-Front/Back,Research,Digital Marketing, Strategy,HR & Leadership,Business Development & Sales,Finance & IB,Other criitical functions",
    "Duration of the internship (Months)": "6-18",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company":
      "https://www.google.com/url?q=https://bit.ly/TBTCC_Site&sa=D&ust=1591885033280000&usg=AFQjCNE4C3YYhknRuJLGmAhdE4UFegMlWw",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link":
      "I assure you that even though this is an unpaid internship the knowledge and experience gained during this long term internship will help you work efficiently in the real world.",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6671697214852669440/",
  },
  {
    Timestamp: "06/11/2020 18:58:34",
    "Company Name": "",
    "Internship Domain": "python django and frontend developer",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?":
      "Our team in Chennai. Remote work is also possible.",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Students who are studying alone can apply. Prior experience in freelancing or projects would be preferred.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "ashwin@ave-promagne.com",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6672842627295141888/",
  },
  {
    Timestamp: "06/11/2020 19:01:21",
    "Company Name": "",
    "Internship Domain": "data scientist",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?":
      "Our team in Chennai. Remote work is also possible.",
    "Website of the company": "",
    "Any expectations from the intern?":
      "Students who are studying alone can apply. Prior experience in freelancing or projects would be preferred.",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "ashwin@ave-promagne.com",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6672842366522679296/",
  },
  {
    Timestamp: "06/11/2020 19:09:29",
    "Company Name":
      "Seed Staged startup (Mumbai based) within the Matrix Partners India Portfolio",
    "Internship Domain": "Growth role",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "experienced professionals from the MBA Class of 2020 (Tier A, B schools preferably) with previous experience in Digital Marketing",
    "Internship Description/Internship Posting Link":
      "looking for relentless -smart -hustlers who are excited about being part of early stage firms and looking to contribute to the growth success story comprehensively",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6673098291003187200/",
  },
  {
    Timestamp: "06/11/2020 19:27:36",
    "Company Name": "",
    "Internship Domain":
      "1. Data Analytics 2. Digital Marketing 3. QC and Setup/Implementation 4. Product Management 5. Learning & Development",
    "Duration of the internship (Months)": "2-3",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?": "",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "shazia.atyab@rategain.com",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6673467991792992256/",
  },
  {
    Timestamp: "06/11/2020 19:30:56",
    "Company Name": "Snap",
    "Internship Domain": "Computational Social Science (CSS) team",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "http://research.snap.com/)",
    "Any expectations from the intern?":
      "-Enrolled in Masters or PhD programs in a technical field, such as Computer Science\n-Experience conducting academic research and applying technical concepts to real-world problems\n-Strong academic performance in technical coursework\n-Clear vision for how research initiatives could contribute to future innovation at Snap",
    "Internship Description/Internship Posting Link":
      "This internship will encompass the study of time series analysis and emerging pattern mining techniques in order to develop an approach for identifying temporal trends in our social media platform.",
    "Contact details for the opportunity(Email)": "accommodations-ext@snap.com",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6673734066409496576/",
  },
  {
    Timestamp: "06/11/2020 19:36:23",
    "Company Name": "Zypp",
    "Internship Domain":
      "Business development, Data Science/AI/ML, Android, Java backend, Operations HR Digital marketing",
    "Duration of the internship (Months)": "2-6",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "All students who are interested in working amidst a growing startup comp can register themselves",
    "Internship Description/Internship Posting Link":
      "This internship comes along with a #PPO based upon your performance.",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6674575039385473024/",
  },
  {
    Timestamp: "06/11/2020 19:42:30",
    "Company Name": "Nearbuy",
    "Internship Domain": "Product Manager- Roadmap & Strategies",
    "Duration of the internship (Months)": "",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?":
      "\n- BE in computer science or similar technical discipline. Excellent verbal and written communication skills.\n\n- Ability to understand and analyze user needs and conduct market research. Create and deliver on product vision, goal, strategy, and roadmap.\n\n- Excellent analytical and problem-solving skills.\n\n- Keen attention to detail and ability to work with user interface designers and usability experts to define customer experience for all customer-facing features.\n\n- Ability to organize, manage, and prioritize tasks. Prior experience working with engineering through the complete technology product lifecycle.\n\n- Interpersonal skills with a keen ability to explain complex concepts across the organization and to large audiences.",
    "Internship Description/Internship Posting Link":
      "We are looking for someone with 0-6 months years of experience building products (in the consumer space is helpful).",
    "Contact details for the opportunity(Email)": "",
    "Anything else you'd like to share?":
      "LinkedIn-https://www.linkedin.com/feed/update/urn:li:activity:6676158480849653761/",
  },
  {
    Timestamp: "06/12/2020 11:35:51",
    "Company Name": "NGO in Women Empowerment Space",
    "Internship Domain": "Social Media",
    "Duration of the internship (Months)": "3-6",
    "Are you open to on-board remote interns?": "Yes",
    "Website of the company": "",
    "Any expectations from the intern?":
      "The person would handle the production of all social content, including posts, updates  across a range of platforms including Instagram, Facebook, LinkedIn and web. The goal is to build the brand, drive engagement and grow the community. Experience in building a community, working on various social platforms (strong expertise in Instagram), basic video and photo editing and being able to utilise tools e.g. canva etc would be required.",
    "Internship Description/Internship Posting Link":
      "Looking for a social media and marketing intern  I am looking for a social media intern to assist with social media and marketing for an NGO working in women empowerment space. Ideally this would be for between 3 and 6 months and would be on a part time, work from home basis with regular virtual meetings as and when required.   The person would handle the production of all social content, including posts, updates  across a range of platforms including Instagram, Facebook, LinkedIn and web. The goal is to build the brand, drive engagement and grow the community. Experience in building a community, working on various social platforms (strong expertise in Instagram), basic video and photo editing and being able to utilise tools e.g. canva etc would be required.  A stipend will be paid based on experience. Please DM me if you are interested or if you have any questions. Thank You!",
    "Contact details for the opportunity(Email)": "harsimran.kaur@insead.edu",
    "Anything else you'd like to share?": "",
  },
  {
    Timestamp: "",
    "Company Name": "",
    "Internship Domain": "full stack developers (Full time)",
    "Duration of the internship (Months)": "Immediately",
    "Are you open to on-board remote interns?": "",
    "Website of the company": "",
    "Any expectations from the intern?": "Role based in Delhi",
    "Internship Description/Internship Posting Link": "",
    "Contact details for the opportunity(Email)": "vineetksingh@gmail.com",
    "Anything else you'd like to share?": "",
  },
];
